var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "init-modal",
    {
      staticClass: "auth-modal",
      attrs: {
        "is-show": _vm.isShow,
        "is-bottom-position": _vm.screenWidth <= 768
      },
      on: { close: _vm.closeModal }
    },
    [
      _c("div", { staticClass: "auth-modal__content" }, [
        _c("div", { staticClass: "auth-modal__img" }, [
          _c(
            "svg",
            {
              attrs: {
                viewBox: "0 0 512 342",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M46.3533 45.5544L55.2963 45.3492L59.8701 45.2808C61.372 45.2808 62.9421 45.2808 64.444 45.2124H64.7171V45.486L64.7853 53.1468V53.4888H64.444L55.4328 53.4204C52.4291 53.4204 49.4253 53.352 46.4216 53.2836H46.2168V53.0784C46.2168 51.7788 46.2851 50.4792 46.2851 49.1796L46.3533 45.5544ZM46.3533 45.5544L46.4216 49.4532C46.4216 50.7528 46.4899 51.984 46.4899 53.2152L46.2851 53.01C49.2888 52.9416 52.2925 52.8732 55.2963 52.8732L64.3075 52.8048L63.9661 53.1468L64.0344 45.486L64.3075 45.7596C62.8056 45.7596 61.3037 45.7596 59.8701 45.6912L55.3645 45.6228L46.3533 45.5544Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M56.4568 35.9099L65.3998 35.7047L69.9736 35.6363C71.4755 35.6363 73.0456 35.6363 74.5475 35.5679H74.8206V35.8415L74.8888 43.5023V43.8443H74.5475L65.5363 43.7759C62.5326 43.7759 59.5288 43.7075 56.5251 43.6391H56.3203V43.4339C56.3203 42.1343 56.3886 40.8347 56.3886 39.5351L56.4568 35.9099ZM56.4568 35.9099L56.5251 39.8087C56.5251 41.1083 56.5934 42.3395 56.5934 43.5707L56.3886 43.3655C59.3923 43.2971 62.396 43.2287 65.3998 43.2287L74.411 43.1603L74.0696 43.5023L74.1379 35.8415L74.411 36.1151C72.9091 36.1151 71.4072 36.1151 69.9736 36.0467L65.5363 36.1151L56.4568 35.9099Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M348.433 78.9333L357.376 78.7281L361.95 78.6597C363.452 78.6597 365.022 78.6597 366.524 78.5913H366.797V78.8649L366.865 86.5257V86.8677H366.524L357.513 86.7993C354.509 86.7993 351.505 86.7309 348.502 86.6625H348.297V86.4573C348.297 85.1577 348.365 83.8581 348.365 82.5585L348.433 78.9333ZM348.433 78.9333L348.502 82.8321C348.502 84.1317 348.57 85.3629 348.57 86.5941L348.365 86.3889C351.369 86.3205 354.373 86.2521 357.376 86.2521L366.388 86.1837L366.046 86.5257L366.114 78.8649L366.388 79.1385C364.886 79.1385 363.384 79.1385 361.95 79.0701L357.445 79.0017L348.433 78.9333Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M358.537 69.2893L367.48 69.0841L372.054 69.0157C373.556 69.0157 375.126 69.0157 376.628 68.9473H376.901V69.2209L376.969 76.8817V77.2237H376.628L367.616 77.1553C364.613 77.1553 361.609 77.0869 358.605 77.0185H358.4V76.8133C358.4 75.5137 358.469 74.2141 358.469 72.9145L358.537 69.2893ZM358.537 69.2893L358.605 73.1881C358.605 74.4877 358.673 75.7189 358.673 76.9501L358.469 76.7449C361.472 76.6765 364.476 76.6081 367.48 76.6081L376.491 76.5397L376.15 76.8817L376.218 69.2209L376.491 69.4945C374.989 69.4945 373.487 69.4945 372.054 69.4261L367.548 69.3577L358.537 69.2893Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M36.2498 35.9099L45.1927 35.7047L49.7666 35.6363C51.2685 35.6363 52.8386 35.6363 54.3405 35.5679H54.6135V35.8415L54.6818 43.5023V43.8443H54.3405L45.3293 43.7759C42.3255 43.7759 39.3218 43.7075 36.3181 43.6391H36.1133V43.4339C36.1133 42.1343 36.1815 40.8347 36.1815 39.5351L36.2498 35.9099ZM36.2498 35.9099L36.3181 39.8087C36.3181 41.1083 36.3863 42.3395 36.3863 43.5707L36.1815 43.3655C39.1853 43.2971 42.189 43.2287 45.1927 43.2287L54.2039 43.1603L53.8626 43.5023L53.9309 35.8415L54.2039 36.1151C52.7021 36.1151 51.2002 36.1151 49.7666 36.0467L45.261 35.9783L36.2498 35.9099Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M186.436 96.5809L177.493 96.7861L172.919 96.8545C171.417 96.8545 169.847 96.8545 168.345 96.9229H168.072V96.6493L168.004 88.9885V88.6465H168.345L177.356 88.7149C180.36 88.7149 183.364 88.7833 186.368 88.8517H186.572V89.0569C186.572 90.3565 186.504 91.6561 186.504 92.9557L186.436 96.5809ZM186.436 96.5809L186.368 92.6821C186.368 91.3825 186.299 90.1513 186.299 88.9201L186.504 89.1253C183.5 89.1937 180.497 89.2621 177.493 89.2621L168.482 89.3305L168.823 88.9885L168.755 96.6493L168.482 96.3757C169.984 96.3757 171.486 96.3757 172.919 96.4441L177.425 96.5125L186.436 96.5809Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M465.647 169.974L456.704 170.179L452.13 170.248C450.628 170.248 449.058 170.248 447.556 170.316H447.283V170.042L447.215 162.382V162.04H447.556L456.567 162.108C459.571 162.108 462.575 162.176 465.579 162.245H465.783V162.45C465.783 163.75 465.715 165.049 465.715 166.349L465.647 169.974ZM465.647 169.974L465.579 166.075C465.579 164.776 465.51 163.544 465.51 162.313L465.715 162.518C462.711 162.587 459.708 162.655 456.704 162.655L447.693 162.724L448.034 162.382L447.966 170.042L447.693 169.769C449.195 169.769 450.696 169.769 452.13 169.837L456.636 169.906L465.647 169.974Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M475.75 179.618L466.807 179.824L462.234 179.892C460.732 179.892 459.162 179.892 457.66 179.96H457.387V179.687L457.318 172.026V171.684H457.66L466.671 171.752C469.675 171.752 472.678 171.821 475.682 171.889H475.887V172.094C475.887 173.394 475.819 174.694 475.819 175.993L475.75 179.618ZM475.75 179.618L475.682 175.72C475.682 174.42 475.614 173.189 475.614 171.958L475.819 172.163C472.815 172.231 469.811 172.3 466.807 172.3L457.796 172.368L458.138 172.026L458.069 179.687L457.796 179.413C459.298 179.413 460.8 179.413 462.234 179.482L466.739 179.55L475.75 179.618Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M64.5804 179.618L55.6375 179.824L51.0636 179.892C49.5618 179.892 47.9916 179.892 46.4898 179.96H46.2167V179.687L46.1484 172.026V171.684H46.4898L55.501 171.752C58.5047 171.752 61.5084 171.821 64.5122 171.889H64.717V172.094C64.717 173.394 64.6487 174.694 64.6487 175.993L64.5804 179.618ZM64.5804 179.618L64.5122 175.72C64.5122 174.42 64.4439 173.189 64.4439 171.958L64.6487 172.163C61.645 172.231 58.6412 172.3 55.6375 172.3L46.6263 172.368L46.9676 172.026L46.8994 179.687L46.6263 179.413C48.1282 179.413 49.63 179.413 51.0636 179.482L55.5692 179.55L64.5804 179.618Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M447.488 35.9099L456.431 35.7047L461.005 35.6363C462.507 35.6363 464.077 35.6363 465.579 35.5679H465.852V35.8415L465.92 43.5023V43.8443H465.579L456.568 43.7759C453.564 43.7759 450.56 43.7075 447.556 43.6391H447.352V43.4339C447.352 42.1343 447.42 40.8347 447.42 39.5351L447.488 35.9099ZM447.488 35.9099L447.556 39.8087C447.556 41.1083 447.625 42.3395 447.625 43.5707L447.42 43.3655C450.424 43.2971 453.427 43.2287 456.431 43.2287L465.442 43.1603L465.101 43.5023L465.169 35.8415L465.442 36.1151C463.94 36.1151 462.438 36.1151 461.005 36.0467L456.499 35.9783L447.488 35.9099Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M429.33 148.291H452.268L465.375 82.764L444.417 73.1196L429.33 148.291Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M363.793 148.291H429.329L444.416 73.1196H378.812L363.793 148.291Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M441.104 185.356H476.193V113.194H441.104V185.356Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M346.932 185.364H356.489L370.825 113.134H346.932V185.364Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M421.79 185.356H441.109V113.194H421.79V185.356Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M327.63 185.356H346.949V113.194H327.63V185.356Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M346.926 185.339H421.814V148.267H346.926V185.339Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M346.926 148.44H421.814V132.298H346.926V148.44Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M436.362 113.133L429.057 112.997L421.753 112.928H421.548V113.133L421.48 121.547V129.96C421.48 135.569 421.411 141.246 421.48 146.855C421.48 152.463 421.48 158.141 421.548 163.749C421.616 169.358 421.684 175.035 421.821 180.644C421.957 175.035 422.026 169.358 422.094 163.749C422.162 158.141 422.162 152.463 422.162 146.855C422.162 141.246 422.162 135.569 422.162 129.96V121.547L422.094 113.133L421.889 113.339L429.194 113.27L436.362 113.133Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M346.931 113.134C346.795 118.811 346.726 124.42 346.658 130.097L346.59 147.06L346.658 164.023L346.726 172.505L346.931 180.987L347.136 172.505L347.204 164.023L347.273 147.06L347.204 130.097C347.136 124.488 347.068 118.811 346.931 113.134Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M346.932 148.291C353.144 148.428 359.424 148.496 365.637 148.565L384.342 148.633L403.047 148.565L412.399 148.496L421.752 148.291L412.399 148.086L403.047 148.018L384.342 147.949L365.637 148.018C359.424 148.086 353.144 148.154 346.932 148.291Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M346.932 132.286C353.144 132.423 359.424 132.491 365.637 132.559L384.342 132.628L403.047 132.559L412.399 132.491L421.752 132.286L412.399 132.081L403.047 132.012L384.342 131.944L365.637 132.012C359.424 132.081 353.144 132.149 346.932 132.286Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M462.848 185.364L463.326 191.178L464.486 204.721H469.538L470.63 191.178L471.108 185.364H462.848Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M471.108 185.364H462.848L463.326 191.178H470.63L471.108 185.364Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M427.35 185.364L427.827 191.178L428.92 204.721H434.04L435.132 191.178L435.61 185.364H427.35Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M435.61 185.364H427.35L427.827 191.178H435.132L435.61 185.364Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M368.367 185.364L368.845 191.178L370.006 204.721H375.057L376.15 191.178L376.627 185.364H368.367Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M376.627 185.364H368.367L368.845 191.178H376.15L376.627 185.364Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M332.869 185.364L333.347 191.178L334.439 204.721H339.491L340.652 191.178L341.129 185.364H332.869Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M332.869 185.364L333.347 191.178H340.652L341.129 185.364H332.869Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M230.331 0H229.717V55.8144H230.331V0Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M254.225 79.207L252.245 83.5162H207.736L205.756 79.207L224.734 66.0742H235.247L254.225 79.207Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M236.545 53.4204L235.248 66.0744H224.735L223.438 53.4204H236.545Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M254.225 79.2754L252.245 83.5162H207.736L205.756 79.2754H254.225Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M282.351 0H281.736V41.9976H282.351V0Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M306.245 65.3901L304.265 69.6993H259.755L257.775 65.3901L276.754 52.2573H287.267L306.245 65.3901Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M288.564 39.5352L287.267 52.2576H276.754L275.457 39.5352H288.564Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M306.245 65.3901L304.265 69.6993H259.755L257.775 65.3901H306.245Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M152.371 66.5532H35.2256V71.6148H152.371V66.5532Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M52.2921 91.4507H47.7182L45.875 71.6147H52.2921V91.4507Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M135.373 91.4507H139.947L141.79 71.6147H135.373V91.4507Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M45.875 71.6147H52.2921V78.4547H46.4894L45.875 71.6147Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M141.79 71.6147L141.176 78.4547H135.373V71.6147H141.79Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M77.6879 36.3204C72.4996 43.3656 67.0383 51.5736 65.7412 60.3972C65.7412 60.534 65.946 60.6024 65.946 60.4656C66.5604 58.0716 67.3113 55.6776 68.2671 53.352C71.6804 52.3944 75.0255 51.642 76.8687 48.222C78.7119 44.7336 78.4388 40.1508 78.0975 36.3888C78.0292 36.1836 77.7561 36.1836 77.6879 36.3204Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M68.3355 53.2837C70.6566 48.0169 73.6603 42.7501 77.4833 38.4409C77.4833 38.4409 77.5515 38.4409 77.5515 38.5093C75.0257 41.5873 73.1825 44.9389 71.3393 48.3589C73.0459 46.5805 74.9574 45.0073 76.5958 43.1605C76.5958 43.0921 76.6641 43.1605 76.6641 43.2289C75.0257 45.1441 73.2507 47.2645 71.1345 48.7009C70.5883 49.7269 69.9739 50.8213 69.4278 51.8473C69.5643 51.7789 69.7009 51.7105 69.8374 51.6421C69.8374 51.6421 69.9057 51.6421 69.8374 51.7105C69.7009 51.7789 69.4961 51.8473 69.3595 51.9157C69.0865 52.3945 68.8134 52.9417 68.5403 53.4205C68.4038 53.4889 68.2673 53.4205 68.3355 53.2837Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M70.0419 51.5055C71.4073 50.6847 72.7726 49.8639 74.0014 48.8379C74.0014 48.8379 74.0697 48.8379 74.0697 48.9063C72.8409 49.9323 71.5438 50.8899 70.1102 51.6423C70.0419 51.6423 69.9737 51.5055 70.0419 51.5055Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M65.1948 60.3288C65.1948 60.4655 65.3996 60.4655 65.3996 60.3288C65.3996 57.3876 65.3996 54.5148 65.4679 51.5736C66.2188 50.0688 67.7889 49.2479 68.9495 48.0167C69.7687 47.1275 70.4513 46.17 70.9975 45.144C72.3628 42.6816 73.1137 39.8772 73.3868 37.0728C73.6599 33.9264 72.4993 23.6664 71.2023 24.0084C70.5196 24.2136 68.3351 29.2752 67.7207 30.9852C66.7649 33.7896 66.0823 36.594 65.6727 39.5352C64.5804 46.3752 64.6487 53.4203 65.1948 60.3288Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M65.127 47.743C65.3318 44.0494 66.151 40.2874 66.9019 36.7306C67.7211 32.9002 68.7451 29.275 70.7248 25.7866C70.7931 25.7182 70.8614 25.7866 70.7931 25.855C69.4278 28.5226 68.472 31.327 67.7211 34.1998C67.8576 33.9946 67.9942 33.7894 68.1307 33.5842C68.199 33.5158 68.3355 33.5842 68.2672 33.6526C68.0624 33.9262 67.9259 34.2682 67.6528 34.5418C66.9702 37.2778 66.4923 40.0822 66.0827 42.955C66.0827 42.8866 66.151 42.8866 66.151 42.8182H66.2192C66.151 42.8866 66.0827 43.0234 66.0827 43.0918C65.8779 44.5282 65.6731 45.9646 65.4683 47.3326C67.9942 45.1438 70.1787 42.613 71.4075 39.4666C70.1787 42.7498 68.3355 45.6226 65.4 47.6062C65.3318 48.0166 65.2635 48.3586 65.2635 48.769C65.2635 48.8374 65.127 48.8374 65.127 48.769C65.127 48.427 65.127 48.085 65.127 47.743C65.127 47.8114 65.127 47.8798 65.127 47.743Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M66.3559 42.4078C68.2673 39.535 70.1106 36.7306 71.5442 33.5158C71.5442 33.4474 71.6124 33.5158 71.6124 33.5158C70.4519 36.6622 68.7452 39.9454 66.4924 42.4762C66.3559 42.5446 66.2876 42.4762 66.3559 42.4078Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M68.8818 32.7633C69.701 31.3269 70.5202 29.9589 71.2712 28.5225C71.2712 28.4541 71.3394 28.5225 71.3394 28.5909C70.725 30.0957 69.9741 31.6005 69.0184 32.9001C68.9501 32.9685 68.8818 32.9001 68.8818 32.7633Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M63.7615 52.8732C63.6932 54.7884 63.4884 56.7036 63.0788 58.6188C63.0788 58.824 63.1471 59.0292 63.1471 59.2344C63.7615 57.114 64.1028 54.9936 64.1711 52.8048C64.1711 52.7364 64.2393 52.668 64.1711 52.5996C64.3076 49.7268 64.0345 46.7856 63.5567 43.9128C62.6692 38.5776 60.6895 33.4476 56.9348 29.412C56.7983 29.2752 56.5935 29.3436 56.5252 29.4804C55.0233 33.3108 55.5695 37.8936 56.7983 41.724C57.4809 43.776 58.5049 45.7596 59.7337 47.538C61.0991 49.3848 62.6692 50.8896 63.7615 52.8732Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M57.4129 31.2589C60.9627 37.0045 63.4203 43.8445 63.6934 50.6161C63.6934 50.7529 63.4886 50.7529 63.4886 50.6161C63.4203 50.0005 63.2838 49.3849 63.2155 48.7693C61.7819 47.3329 60.2801 45.8965 59.1878 44.1181C59.1878 44.1181 59.1878 44.0497 59.2561 44.0497C60.5531 45.4861 61.7137 46.9909 63.1473 48.2905C62.8742 46.7857 62.6011 45.2809 62.2598 43.8445C62.1915 43.7077 62.055 43.6393 61.9867 43.5025C61.9185 43.4341 62.055 43.2973 62.1233 43.3657L62.1915 43.4341C61.7137 41.4505 61.0993 39.4669 60.3483 37.5517C59.4609 36.4573 58.4369 35.5681 57.8225 34.2685C57.8225 34.2685 57.8225 34.2001 57.8907 34.2685C58.4369 35.0209 58.9147 35.7733 59.5291 36.4573C59.7339 36.7309 60.007 37.0045 60.2801 37.2781C59.4609 35.2261 58.5051 33.2425 57.4129 31.2589C57.3446 31.1905 57.2081 31.2589 57.4129 31.2589Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M58.0952 38.3042C59.2557 39.8774 60.5528 41.3138 61.5768 42.887C61.5768 42.9554 61.5085 42.9554 61.5085 42.9554C60.1432 41.6558 58.9827 39.9458 58.0269 38.3726C57.9587 38.3042 58.0952 38.3042 58.0952 38.3042Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M61.782 43.2975C61.8502 43.3659 61.782 43.4343 61.782 43.3659V43.2975C61.6454 43.2975 61.7137 43.2291 61.782 43.2975Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M51.3369 40.8346C51.6099 43.7758 53.1801 47.3326 55.0915 49.5898C55.9107 50.6158 56.9347 51.3682 58.0953 51.9838C59.3923 52.5994 60.7577 53.3518 62.123 53.899C62.7374 55.5406 63.2153 57.1822 63.5566 58.9606C63.6249 58.8238 63.6249 58.687 63.6931 58.4818C62.8057 51.0262 57.9587 44.665 51.7465 40.561C51.5417 40.4242 51.2686 40.561 51.3369 40.8346Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M53.4531 43.0235C53.3848 42.9551 53.4531 42.8867 53.5213 42.9551C56.7981 45.4175 59.7336 48.9059 61.372 52.6679C61.4403 52.7363 61.3037 52.8731 61.2355 52.7363C60.9624 52.2575 60.6211 51.7103 60.348 51.2315C58.9144 50.9579 57.6173 50.0003 56.5251 49.0427C56.5251 49.0427 56.5251 48.9743 56.5933 48.9743C57.1395 49.4531 57.7539 49.9319 58.3683 50.2055C58.9144 50.4791 59.5288 50.6843 60.1432 50.8895C59.5971 50.0687 59.0509 49.2479 58.5048 48.4955C57.0029 47.9483 55.5693 47.0591 54.2723 46.1015C54.204 46.1015 54.2723 46.0331 54.3405 46.0331C55.6376 46.7855 56.9347 47.5379 58.3 48.1535C57.4125 46.9907 56.5251 45.9647 55.5011 44.8703C55.0232 44.5967 54.5453 44.3915 54.0675 44.1179C53.9992 44.1179 54.0675 44.0495 54.0675 44.0495C54.4088 44.1863 54.8184 44.3915 55.1597 44.5967C54.6136 44.1863 54.0675 43.5707 53.4531 43.0235Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M53.5893 45.6226C53.6576 45.691 53.7258 45.7594 53.7941 45.7594V45.8278C53.6576 45.8278 53.5893 45.7594 53.5893 45.6226C53.521 45.691 53.521 45.6226 53.5893 45.6226Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M71.2708 66.5535H58.5049L59.1193 58.2087L59.3924 55.4727H70.2468L70.5198 58.2087L71.2708 66.5535Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M70.5197 58.2087H59.1191L59.3922 55.4727H70.2466L70.5197 58.2087Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M71.1342 53.2153H58.5049V56.0197H71.1342V53.2153Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M102.188 66.562V36.1924H94.5426V66.562H102.188Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M102.173 37.9551V34.6035H94.527V37.9551H102.173Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M102.167 43.4211V42.1899H94.5211V43.4211H102.167Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M102.209 62.6143V59.2627H94.5631V62.6143H102.209Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M107.513 66.5709V31.1396H102.188V66.5709H107.513Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M106.424 48.0843V34.4727H103.215V48.0843H106.424Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M145.487 62.7568L120.338 37.8486L116.595 41.643L141.744 66.5512L145.487 62.7568Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M138.814 57.6251L129.152 48.0562L126.897 50.3425L136.558 59.9115L138.814 57.6251Z",
                  fill: "#DBDBDB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M116.566 66.5707V39.6895H107.487V66.5707H116.566Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M116.538 63.7388V61.208H107.459V63.7388H116.538Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M116.574 59.5333V58.5757H107.495V59.5333H116.574Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M84.5999 66.5846L94.5645 43.3291L88.7933 40.8466L78.8287 64.1021L84.5999 66.5846Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M85.7438 64.0984L86.6592 61.9614L80.888 59.4795L79.9726 61.6165L85.7438 64.0984Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M91.5892 50.281L92.5049 48.144L86.7337 45.6615L85.818 47.7985L91.5892 50.281Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M90.6519 52.5715L91.002 51.7544L85.2308 49.2719L84.8807 50.089L90.6519 52.5715Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M256 312.656C379.212 312.656 479.095 300.989 479.095 286.596C479.095 272.203 379.212 260.536 256 260.536C132.788 260.536 32.9043 272.203 32.9043 286.596C32.9043 300.989 132.788 312.656 256 312.656Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M256 252.328C320.962 252.328 373.624 244.947 373.624 235.843C373.624 226.739 320.962 219.359 256 219.359C191.039 219.359 138.377 226.739 138.377 235.843C138.377 244.947 191.039 252.328 256 252.328Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M35.499 204.721L90.6585 204.516L145.75 204.448L256 204.379L366.251 204.448L421.342 204.516L476.502 204.721L421.342 204.858L366.251 204.927L256 205.063L145.75 204.927L90.6585 204.858L35.499 204.721Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M67.9249 131.465C68.1297 128.182 68.5393 124.967 69.2903 121.752C69.9729 118.879 70.9287 115.938 72.7719 113.544C74.4103 111.355 76.7996 109.645 79.5303 109.303C82.1927 108.961 84.6503 110.193 86.63 111.834C89.0876 113.886 90.9991 116.691 92.774 119.29C94.7537 122.299 96.4604 125.377 98.0306 128.524C98.0988 128.661 97.894 128.729 97.894 128.592C96.5287 125.925 94.8903 123.257 93.1836 120.863C91.5452 118.537 89.7703 116.28 87.7223 114.297C85.8791 112.518 83.558 110.877 80.9639 110.74C78.3697 110.671 75.9121 112.108 74.342 114.16C72.5671 116.417 71.6796 119.29 70.9969 122.026C70.246 125.035 69.9047 128.182 69.6316 131.26C69.0855 137.621 68.9489 144.051 68.8124 150.48C68.7442 154.105 68.6759 157.731 68.6759 161.356C68.6759 163.203 68.6759 165.049 68.6076 166.896C68.6076 168.675 68.6759 170.453 68.4028 172.231C68.3345 172.573 67.7884 172.573 67.7201 172.231C67.4471 170.59 67.5153 168.88 67.4471 167.17C67.4471 165.46 67.3788 163.681 67.3788 161.971C67.3788 158.62 67.3105 155.2 67.3105 151.848C67.3788 145.077 67.4471 138.237 67.9249 131.465Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M77.0046 126.677C77.3459 124.899 77.9603 122.505 78.9843 121.137C80.8275 118.606 82.8072 119.7 80.964 122.505C78.9843 125.514 78.643 127.977 78.3699 129.345C78.3699 129.345 81.4419 133.791 85.1966 135.979C85.06 134.269 84.5822 131.67 84.8552 129.139C85.6062 123.667 88.883 123.941 88.0638 128.319C87.3811 131.807 87.108 135.501 87.3128 137.142C88.4051 137.963 90.3848 138.715 91.3406 139.126C91.1358 138.51 90.931 137.758 90.6579 136.8C89.3608 131.875 92.5694 130.371 92.7059 133.107C92.7742 135.364 93.6616 138.921 94.003 140.083C95.7779 140.699 97.2798 141.109 98.1672 141.451C101.922 142.751 104.311 145.624 104.311 145.624C106.018 144.119 107.383 142.272 108.476 140.22C107.315 139.263 105.54 137.758 103.014 135.979C98.3038 132.628 99.9422 128.455 103.697 131.055C106.359 132.97 108.476 136.458 109.431 138.237C110.728 135.159 111.411 131.739 111.548 128.387C107.861 124.899 98.7134 120.042 101.444 120.042C103.902 120.042 109.5 123.667 111.479 125.104C111.411 124.146 111.343 123.189 111.138 122.231C107.656 119.974 96.324 116.417 98.1672 115.391C100.147 114.297 108.066 117.922 110.455 119.085C109.909 117.375 109.226 115.938 108.339 114.775C103.56 108.346 94.8222 106.089 91.0675 107.32C88.4051 108.209 89.156 114.981 88.6099 114.775C77.9603 110.329 73.0451 113.407 77.0046 126.677ZM103.356 125.925C104.106 124.967 107.656 127.703 106.632 129.208C105.608 130.644 102.4 127.087 103.356 125.925ZM84.9235 120.111C85.8792 120.726 84.5139 124.146 83.0803 123.12C81.8515 122.231 83.9678 119.495 84.9235 120.111Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M86.357 121.137C86.8349 120.179 87.381 119.221 87.9271 118.264C88.4733 117.375 89.0194 116.417 89.7021 115.665C89.5655 115.459 89.429 115.254 89.2242 115.117C89.1559 115.049 89.2925 114.912 89.3607 114.981C89.5655 115.186 89.7021 115.391 89.9069 115.596L89.9751 115.665C90.6578 116.485 91.2722 117.306 91.8866 118.127C92.9106 118.332 94.0029 118.674 95.0269 119.016C96.0509 119.358 97.1431 119.769 98.1671 120.179C98.3037 120.247 98.2354 120.384 98.0989 120.384C97.0749 119.905 96.0509 119.495 95.0269 119.153C94.0029 118.811 93.0471 118.537 92.0231 118.264C92.3645 118.743 92.7058 119.221 92.9789 119.7C94.8903 120.247 96.7335 121.137 98.5085 121.957C100.352 122.847 102.195 123.873 103.97 124.899C104.038 124.967 103.97 125.104 103.902 125.035C102.127 124.009 100.352 123.12 98.5085 122.231C96.8018 121.41 94.9586 120.726 93.252 119.974C97.621 126.814 100.283 134.748 103.833 142.135C103.902 142.272 103.697 142.341 103.697 142.204C102.604 139.605 101.376 137.142 100.215 134.611C99.1911 132.354 98.1671 130.029 97.0749 127.771C96.7335 127.087 96.4605 126.472 96.1191 125.788C96.3239 129.481 96.2557 133.175 96.8018 136.8C96.8018 136.937 96.597 136.937 96.597 136.8C96.3239 132.901 95.6413 129.003 95.7095 125.104C95.7095 125.104 95.7095 125.104 95.7095 125.035C94.9586 123.531 94.1394 122.026 93.3202 120.589C91.8866 124.009 90.3165 127.498 89.6338 131.191C89.6338 131.328 89.429 131.26 89.429 131.123C90.3847 127.429 91.3405 123.736 93.1154 120.316C92.1597 118.743 91.1357 117.238 90.0434 115.87C89.5655 116.759 88.9511 117.648 88.405 118.537C87.8589 119.358 87.3127 120.247 86.8349 121.137C85.7426 122.983 84.8551 124.899 84.1042 126.951C84.0359 127.087 83.8994 127.019 83.8994 126.882C84.5138 125.035 85.4013 123.052 86.357 121.137Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M51.7464 129.481C54.5453 126.677 57.8221 122.915 62.1912 122.915C66.4237 122.915 69.4957 126.335 71.2706 129.823C73.1138 133.517 73.7965 137.621 74.3426 141.657C74.957 146.513 75.2984 151.369 75.4349 156.226C75.5032 158.893 75.5032 161.629 75.4349 164.365C75.3666 167.101 75.2984 169.837 74.8205 172.573C74.7522 172.984 74.0696 173.052 74.0013 172.573C73.8648 170.316 73.933 167.991 74.0013 165.733C74.0013 163.476 74.0013 161.219 73.8648 159.03C73.7282 154.516 73.3869 150.001 72.8408 145.487C72.3629 141.52 72.0216 137.484 70.861 133.722C69.7688 130.302 67.789 126.403 64.3757 124.899C59.6653 122.847 55.0232 126.609 51.9512 129.755C51.7464 129.687 51.6098 129.618 51.7464 129.481Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M37.3418 135.843C37.3418 136.458 37.4101 137.006 37.4101 137.553C38.7071 136.664 40.3455 135.843 42.0522 135.638C46.0799 135.227 45.8069 138.237 43.1445 138.374C40.6186 138.51 38.9119 138.921 37.6831 139.468C38.3658 144.735 39.7994 149.044 40.0042 149.044C40.209 149.112 45.1242 148.77 50.5855 147.676C49.5615 145.556 47.3087 142.751 48.4693 142.478C49.6298 142.272 50.8586 144.735 51.5413 147.471C54.2037 146.924 56.8661 146.24 59.2554 145.35C57.4805 143.846 54.7498 141.93 55.8421 141.11C56.8661 140.289 59.0506 142.956 60.3477 144.94C61.6447 144.393 62.8053 143.777 63.6927 143.093C61.3034 139.605 55.569 138.921 56.3199 136.39C57.0709 133.791 62.4639 137.348 64.9215 142.067C67.7887 139.126 68.6079 134.885 68.3349 131.328C65.8773 131.055 61.0986 131.534 61.4399 129.755C61.7813 128.045 65.2629 128.319 68.0618 129.345C67.7205 127.703 67.1061 126.335 66.4234 125.378C63.8293 122.026 55.8421 126.267 55.8421 126.267C55.8421 126.267 56.7295 118.196 53.6575 116.828C51.8826 116.007 48.8106 116.007 45.6703 117.854C47.4453 117.99 49.4933 118.538 50.3807 119.769C51.473 121.342 49.7663 122.163 48.6741 121.41C47.9231 120.932 46.4895 119.29 43.8954 119.085C42.8714 119.906 41.9157 121 41.0282 122.3C40.7551 122.71 40.4821 123.12 40.209 123.599C42.7349 122.573 46.0117 122.026 49.5615 123.736C53.0431 125.446 51.0634 129.071 48.1279 127.635C45.1925 126.267 42.3253 124.83 39.185 125.651C38.0245 128.319 37.6149 131.534 37.6831 134.612C38.8437 133.722 40.6186 132.696 42.8031 132.149C46.2165 131.26 47.3087 133.312 43.4858 133.722C40.7551 134.201 38.7071 135.09 37.3418 135.843ZM41.5061 130.302C41.3013 129.208 43.6906 128.866 44.1002 129.755C44.4415 130.508 41.7791 131.397 41.5061 130.302ZM62.3957 136.458C62.6005 135.843 64.2389 136.527 64.1023 137.279C63.8975 138.374 62.1909 137.074 62.3957 136.458ZM50.8586 140.426C52.0191 139.947 53.9306 142.888 52.6335 143.572C51.3365 144.256 49.9029 140.768 50.8586 140.426Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M40.4137 148.497C42.1886 145.487 43.9635 142.478 45.875 139.536C46.7625 138.168 47.6499 136.8 48.6057 135.501C48.4691 135.501 48.3326 135.432 48.1961 135.432C47.9913 135.364 47.7182 135.364 47.5134 135.296C46.9673 135.227 46.4211 135.09 45.875 135.09C45.3289 135.022 44.851 135.022 44.3049 135.022C43.7587 135.022 43.1443 135.022 42.5982 135.09C42.5299 135.09 42.5299 135.022 42.5982 135.022C43.1443 135.022 43.7587 134.954 44.3049 134.954C44.851 134.954 45.3971 134.954 45.9433 135.022C46.4211 135.022 46.9673 135.09 47.4451 135.159C47.7182 135.227 47.9913 135.227 48.2643 135.296C48.4009 135.296 48.6057 135.364 48.7422 135.432C49.6979 134.064 50.7219 132.765 51.7459 131.465C48.6057 130.029 45.3971 128.798 41.9155 128.319C41.8473 128.319 41.8473 128.25 41.9155 128.25C45.3289 128.798 48.8105 129.687 51.8825 131.26C52.4286 130.576 53.043 129.824 53.5891 129.14C54.2718 128.387 54.9545 127.566 55.5006 126.746C55.5689 126.677 55.6371 126.746 55.5689 126.814C54.7497 127.703 53.9987 128.661 53.3161 129.618C54.6131 130.508 55.7737 131.534 56.9342 132.56C58.0947 133.586 59.3235 134.748 60.4158 135.843C60.4841 135.911 60.4158 135.98 60.3475 135.911C59.2553 134.817 58.0947 133.722 56.8659 132.696C55.6371 131.67 54.4083 130.781 53.1795 129.755C52.9065 130.097 52.6334 130.508 52.3603 130.85C52.2238 131.055 52.0873 131.192 51.9507 131.397C51.9507 131.397 51.9507 131.397 51.9507 131.465C51.4729 132.081 50.995 132.696 50.5854 133.312C51.1315 134.064 51.5411 134.954 51.9507 135.843C52.3603 136.664 52.7017 137.553 53.043 138.442C53.7257 140.289 54.1353 142.204 54.5449 144.051C54.5449 144.119 54.4766 144.119 54.4766 144.051C54.1353 142.136 53.5209 140.357 52.8382 138.51C52.4969 137.621 52.0873 136.664 51.6777 135.774C51.3363 134.954 50.8585 134.201 50.5171 133.38C50.1075 133.928 49.6979 134.475 49.2883 135.022C49.1518 135.159 49.0835 135.364 48.947 135.501C48.947 135.569 48.947 135.569 48.8787 135.569C47.6499 137.279 46.4894 139.058 45.3289 140.836C45.3971 140.973 45.4654 141.11 45.4654 141.246C45.5337 141.452 45.6019 141.657 45.6702 141.93C45.8067 142.341 45.875 142.82 46.0115 143.298C46.0798 143.709 46.1481 144.119 46.2163 144.598C46.2846 145.077 46.2163 145.624 46.3529 146.034C46.3529 146.103 46.2846 146.103 46.2846 146.034C46.3529 145.624 46.2163 145.077 46.2163 144.666C46.1481 144.188 46.0798 143.709 45.9433 143.298C45.875 142.888 45.7385 142.478 45.6019 142.067C45.5337 141.862 45.4654 141.657 45.3971 141.452C45.3289 141.315 45.3289 141.246 45.2606 141.11C44.7145 141.93 44.1683 142.82 43.6905 143.64C42.6665 145.35 41.6425 146.992 40.6185 148.702C40.4819 148.634 40.3454 148.565 40.4137 148.497Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M68.0615 171.547C68.1298 169.837 68.4029 168.127 68.5394 166.417C68.7442 164.707 68.949 162.997 69.0855 161.287C69.4269 158.004 69.6317 154.653 70.3826 151.438C71.0653 148.702 72.2941 146.034 74.4103 144.051C75.5026 143.093 76.8679 142.272 78.3015 142.204C79.8034 142.135 81.237 142.614 82.4658 143.503C83.8994 144.461 84.9917 145.829 85.9474 147.197C86.9714 148.633 87.8589 150.07 88.6781 151.643C88.6781 151.711 88.6098 151.711 88.6098 151.711C87.1079 149.112 85.0599 146.923 82.6706 145.077C81.5783 144.256 80.3495 143.64 78.9159 143.503C77.5506 143.435 76.3218 144.051 75.2978 144.94C73.3181 146.65 72.1575 149.181 71.4749 151.711C70.6557 154.653 70.3826 157.799 69.973 160.809C69.6999 162.587 69.4951 164.434 69.2903 166.212C69.0855 167.991 68.8807 169.837 68.5394 171.616C68.6077 172.026 68.0615 171.958 68.0615 171.547Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M76.4581 158.346C76.936 159.03 77.5504 159.646 78.3013 160.261C78.0282 158.62 77.6869 155.679 78.5061 154.105C79.8032 151.643 81.3733 152.874 80.5541 154.995C79.4618 158.004 79.257 160.056 79.3253 161.014C80.9637 162.108 82.9434 162.997 84.9914 163.681C84.7866 162.861 84.7184 161.835 84.7866 160.74C85.0597 158.141 87.0394 158.209 86.4933 160.877C86.2885 162.04 86.2202 163.203 86.2202 164.092C90.7941 165.528 95.0266 166.075 95.0266 166.075C96.7333 163.818 97.8938 161.629 98.6448 159.577C96.5285 159.03 92.2277 158.893 92.296 157.389C92.4325 155.337 96.5968 156.91 98.9861 158.415C99.6005 156.431 99.8053 154.584 99.737 152.943C98.7813 152.601 97.0064 152.259 93.8661 151.985C89.497 151.575 89.7018 149.112 92.9104 149.181C95.2314 149.249 98.1669 150.685 99.6005 151.369C98.713 145.419 94.1392 141.588 90.521 141.451C84.4453 141.178 86.6298 148.839 86.6298 148.839C86.6298 148.839 82.4656 145.897 78.5744 145.966C74.7514 146.034 72.2938 152.532 76.4581 158.346ZM92.7738 147.334C92.6373 146.445 95.368 146.239 95.5045 147.402C95.641 148.565 92.9104 148.223 92.7738 147.334ZM97.1429 156.226C97.0746 155.679 98.2352 155.542 98.5082 156.294C98.713 156.773 97.2112 156.841 97.1429 156.226ZM82.4656 156.773C83.353 156.91 83.8992 160.193 82.329 160.125C81.1685 160.125 81.7146 156.636 82.4656 156.773Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M83.7627 160.467C83.8992 160.056 84.0358 159.646 84.1723 159.235C84.0358 159.646 83.9675 160.056 83.8992 160.535C83.831 160.535 83.7627 160.535 83.7627 160.467Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M85.4008 155.132C85.6738 154.311 86.0152 153.422 86.3565 152.601C86.5613 152.19 86.6978 151.712 86.9026 151.301C87.0392 150.959 87.1757 150.549 87.4488 150.207C87.244 149.865 87.1074 149.523 86.9709 149.112C86.9709 149.044 86.9709 149.044 87.0392 149.112C87.517 149.66 87.8584 150.344 88.1997 150.959C88.3362 151.233 88.541 151.575 88.6776 151.848C89.0189 151.848 89.3602 151.917 89.7016 151.985C90.0429 152.054 90.4525 152.122 90.7938 152.19C91.1352 152.259 91.5448 152.327 91.8861 152.464C92.2274 152.532 92.637 152.669 92.9784 152.738C93.0466 152.738 93.0466 152.874 92.9784 152.874C92.637 152.738 92.2274 152.669 91.8178 152.601C91.4765 152.532 91.1352 152.464 90.7938 152.396C90.4525 152.327 90.1112 152.327 89.7016 152.259C89.4285 152.259 89.1554 152.19 88.8824 152.19C89.0189 152.464 89.1554 152.669 89.292 152.943C89.292 153.011 89.3602 153.011 89.3602 153.08C89.6333 153.08 89.9746 153.148 90.2477 153.216C90.589 153.285 90.8621 153.353 91.2034 153.422C91.8178 153.558 92.5005 153.695 93.1149 153.9C94.412 154.242 95.709 154.721 97.0744 155.132C97.1426 155.132 97.0744 155.268 97.0061 155.268C95.709 154.858 94.412 154.448 93.0466 154.174C92.4322 154.037 91.8178 153.9 91.2034 153.764C90.8621 153.695 90.589 153.627 90.2477 153.558C89.9746 153.49 89.7698 153.49 89.4968 153.422C90.1794 154.653 90.7938 155.952 91.4082 157.252C92.7053 160.056 93.7293 162.929 94.8216 165.802C94.8216 165.87 94.7533 165.939 94.685 165.87C93.661 162.998 92.364 160.193 91.0669 157.457C90.7938 156.978 90.589 156.431 90.316 155.952C90.316 156.021 90.2477 156.158 90.2477 156.226C90.1794 156.568 90.1112 156.91 90.0429 157.252C89.9064 157.936 89.8381 158.62 89.7016 159.304C89.4968 160.672 89.1554 162.177 89.2237 163.545C89.2237 163.613 89.0872 163.613 89.0872 163.545C89.2237 162.861 89.2237 162.177 89.2237 161.493C89.292 160.809 89.292 160.056 89.4285 159.372C89.4968 158.688 89.565 158.004 89.7016 157.32C89.7698 156.978 89.8381 156.636 89.9064 156.294C89.9746 156.021 89.9746 155.747 90.1112 155.542C89.7698 154.79 89.4285 154.106 89.0189 153.353C88.6776 152.669 88.3362 151.985 87.9949 151.37C87.8584 151.096 87.6536 150.822 87.517 150.48C87.4488 150.822 87.244 151.164 87.1074 151.506C86.9709 151.917 86.7661 152.259 86.6296 152.669C86.2882 153.49 85.9469 154.379 85.6056 155.268C85.1277 156.5 84.6498 157.731 84.2402 159.03C84.6498 157.662 84.9229 156.363 85.4008 155.132Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M84.1719 159.167C84.1719 159.099 84.2401 158.962 84.2401 158.894C84.2401 159.03 84.1719 159.099 84.1719 159.167Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M57.8906 168.264L58.3002 177.361L59.3925 200.823H83.5589L84.7194 177.361L85.129 168.264H57.8906Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M57.8906 168.264L58.3002 177.361H84.7194L85.129 168.264H57.8906Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M56.1676 171.93H86.8193V164.542H56.1676V171.93Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M81.6476 200.823H77.415V204.653H81.6476V200.823Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M81.6476 200.823H77.415V202.738H81.6476V200.823Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M65.6046 200.823H61.3721V204.653H65.6046V200.823Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M65.6046 200.823H61.3721V202.738H65.6046V200.823Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M322.969 243.504C322.559 241.589 294.16 195.555 292.044 194.461C291.771 194.324 276.274 203.285 276.274 203.285C275.591 204.037 248.558 195.555 248.558 195.555L245.145 228.866L295.525 232.56C295.525 232.56 301.942 237.211 307.813 241.041C311.431 243.435 314.64 245.419 315.596 245.761C318.053 246.719 323.446 245.351 322.969 243.504Z",
                  fill: "#F7A9A0"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M315.596 245.829C314.64 245.487 311.431 243.435 307.813 241.11C301.942 237.279 295.525 232.628 295.525 232.628L284.329 231.807L269.447 201.78C273.202 202.806 276.069 203.49 276.274 203.285C276.274 203.285 291.77 194.324 291.975 194.461C294.092 195.487 322.49 241.589 322.9 243.435C323.446 245.351 318.053 246.719 315.596 245.829Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M323.241 243.572C322.763 241.657 294.228 195.556 292.043 194.461C291.224 194.051 283.715 197.744 276.273 203.285L294.705 232.97C294.705 232.97 313.137 245.146 315.663 246.035C318.257 246.924 323.719 245.488 323.241 243.572Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M320.989 244.051C316.006 236.459 296.686 205.337 292.317 197.402C292.249 197.334 292.317 197.334 292.386 197.402C297.506 204.858 316.552 236.117 321.126 243.983C321.262 244.12 321.126 244.188 320.989 244.051Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M312.182 244.12C310.953 242.341 310.748 240.016 311.226 238.306C311.704 236.664 312.66 234.954 314.298 233.997C314.366 233.997 314.366 234.065 314.366 234.065C311.636 236.391 310.68 240.768 312.318 243.983C312.318 244.12 312.25 244.188 312.182 244.12Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M296.959 234.886C294.979 231.808 293.887 227.567 295.184 224.078C295.252 223.942 295.457 224.01 295.457 224.147C295.73 227.84 296.344 231.124 297.368 234.749C297.505 234.954 297.095 235.159 296.959 234.886Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M299.416 236.732C297.436 233.654 296.344 229.414 297.641 225.925C297.709 225.788 297.914 225.857 297.914 225.994C298.187 229.687 298.801 232.97 299.825 236.596C299.894 236.801 299.552 236.938 299.416 236.732Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M301.806 238.511C299.827 235.433 298.734 231.192 300.032 227.703C300.1 227.567 300.305 227.635 300.305 227.772C300.578 231.465 301.192 234.749 302.216 238.374C302.284 238.579 301.943 238.784 301.806 238.511Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M304.195 240.357C302.215 237.279 301.123 233.039 302.42 229.55C302.488 229.413 302.693 229.482 302.693 229.619C302.966 233.312 303.581 236.595 304.605 240.221C304.673 240.426 304.332 240.563 304.195 240.357Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M286.241 203.901C284.125 200.412 289.518 197.061 291.634 200.549C293.819 204.106 288.426 207.389 286.241 203.901Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M295.183 240.289C296.276 237.28 296.071 233.928 296.207 230.782C296.207 230.44 295.866 230.303 295.593 230.371C295.593 230.303 295.525 230.303 295.457 230.303C292.931 232.15 290.541 235.091 289.313 238.032C288.562 239.81 288.493 242.615 290.814 243.367C292.999 244.12 294.569 242.068 295.183 240.289ZM292.726 242.068C289.176 243.846 289.859 239.195 290.473 237.895C290.883 237.074 291.361 236.254 291.838 235.501C292.862 233.86 294.159 232.423 295.32 230.918C295.115 232.492 295.115 233.996 294.979 235.57C294.91 237.348 294.706 241.042 292.726 242.068Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M286.719 220.59C284.875 222.095 285.831 224.626 287.196 226.062C289.313 228.388 292.59 230.371 295.593 231.192C295.662 231.192 295.73 231.192 295.73 231.124C296.003 231.124 296.276 230.85 296.139 230.576C294.911 227.704 293.955 224.42 291.907 221.958C290.678 220.522 288.494 219.154 286.719 220.59ZM293.409 226.541C294.023 227.977 294.638 229.414 295.32 230.782C293.682 229.756 291.975 228.866 290.473 227.704C289.722 227.156 288.971 226.541 288.357 225.925C287.333 224.899 285.08 220.795 289.04 221.274C291.156 221.411 292.658 224.831 293.409 226.541Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M257.228 188.715C257.228 188.715 215.449 167.99 196.539 167.648C174.011 167.238 155.716 193.503 182.749 213.613C206.643 231.397 283.511 232.492 283.511 232.492L266.513 199.66C266.513 199.66 245.555 190.767 217.77 189.057L256.341 198.086L257.228 188.715Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M256.205 195.145C252.928 194.187 249.514 193.503 246.169 192.819C242.756 192.135 239.411 191.451 235.998 190.836C229.239 189.605 222.344 188.647 215.449 188.1C214.835 188.031 214.152 188.031 213.538 187.963C213.401 187.895 213.265 187.895 213.128 187.826C212.787 187.689 212.514 187.621 212.173 187.484C211.558 187.279 210.944 187.142 210.329 187.005C209.032 186.663 207.735 186.39 206.506 186.048C206.438 186.048 206.37 186.116 206.438 186.185C207.735 186.595 208.964 187.074 210.193 187.484C210.534 187.621 210.944 187.689 211.285 187.826C208.759 187.689 206.233 187.689 203.707 187.689C203.639 187.689 203.639 187.826 203.707 187.826C207.121 187.963 210.602 188.237 214.016 188.647C217.429 189.057 220.774 189.399 224.187 189.947C231.014 190.973 237.841 192.272 244.599 193.64C248.422 194.393 252.177 195.282 256.068 195.761C256.478 195.829 256.614 195.282 256.205 195.145Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M275.661 230.713C274.637 228.593 273.75 226.404 272.862 224.284C271.906 222.163 271.019 219.974 270.063 217.854C268.22 213.545 261.393 199.181 260.642 198.086C260.574 198.018 260.506 198.086 260.506 198.155C260.779 199.249 265.011 208.757 265.967 210.877C267.947 215.118 269.995 219.29 272.043 223.531C272.657 224.762 273.203 225.925 273.818 227.088C274.432 228.251 275.047 229.482 275.593 230.713C275.593 230.85 275.729 230.85 275.661 230.713Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M175.241 238.921C175.855 237.074 208.487 193.914 210.671 193.093C210.944 192.956 225.485 203.353 225.485 203.353C226.1 204.174 253.816 198.292 253.816 198.292L254.089 231.808L203.64 230.713C203.64 230.713 196.813 234.749 190.601 238.032C186.778 240.084 183.365 241.794 182.409 241.999C179.883 242.683 174.627 240.768 175.241 238.921Z",
                  fill: "#F7A9A0"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M182.408 241.999C183.364 241.726 186.777 240.016 190.6 238.032C196.813 234.749 203.639 230.713 203.639 230.713L214.903 230.987L232.516 202.532C228.625 203.216 225.758 203.627 225.553 203.353C225.553 203.353 211.012 192.956 210.739 193.093C208.486 193.914 175.923 237.074 175.309 238.921C174.626 240.768 179.883 242.683 182.408 241.999Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M174.967 238.99C175.581 237.074 208.349 193.982 210.67 193.093C211.558 192.751 218.658 197.197 225.553 203.353L204.39 231.124C204.39 231.124 184.866 241.452 182.271 242.136C179.677 242.82 174.353 240.905 174.967 238.99Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M177.152 239.673C182.818 232.56 205.004 203.421 210.056 195.966C210.124 195.897 210.056 195.897 209.988 195.897C204.185 202.806 182.272 232.149 177.015 239.537C176.947 239.742 177.015 239.81 177.152 239.673Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M185.958 240.563C187.324 238.921 187.802 236.596 187.46 234.886C187.187 233.244 186.368 231.397 184.866 230.303C184.798 230.303 184.73 230.371 184.798 230.371C187.324 232.97 187.87 237.416 185.89 240.426C185.822 240.563 185.89 240.631 185.958 240.563Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M201.932 232.902C204.185 230.029 205.687 225.925 204.731 222.3C204.663 222.163 204.526 222.231 204.458 222.368C203.844 225.993 202.956 229.276 201.523 232.696C201.454 232.902 201.796 233.107 201.932 232.902Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M199.406 234.475C201.659 231.602 203.16 227.498 202.205 223.873C202.136 223.736 202 223.805 201.932 223.941C201.317 227.567 200.43 230.85 198.996 234.27C198.86 234.475 199.201 234.68 199.406 234.475Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M196.813 236.048C199.066 233.175 200.568 229.071 199.612 225.446C199.544 225.309 199.407 225.378 199.339 225.515C198.725 229.14 197.837 232.423 196.403 235.843C196.335 236.048 196.677 236.253 196.813 236.048Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M194.217 237.621C196.47 234.749 197.972 230.645 197.016 227.019C196.948 226.883 196.812 226.951 196.743 227.088C196.129 230.713 195.241 233.996 193.808 237.416C193.739 237.621 194.081 237.827 194.217 237.621Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M215.517 203.011C217.975 199.728 212.923 195.898 210.466 199.181C208.076 202.464 213.06 206.294 215.517 203.011Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M207.256 241.862C209.577 241.315 209.782 238.579 209.236 236.732C208.28 233.722 206.232 230.508 203.843 228.456C203.775 228.387 203.706 228.456 203.706 228.456C203.433 228.387 203.092 228.456 203.092 228.798C202.955 231.944 202.409 235.296 203.229 238.374C203.706 240.22 205.072 242.409 207.256 241.862ZM203.843 233.654C203.843 232.081 203.979 230.576 203.979 229.003C205.003 230.644 206.164 232.149 207.051 233.928C207.461 234.748 207.871 235.569 208.212 236.459C208.69 237.827 208.963 242.478 205.618 240.357C203.638 239.194 203.775 235.501 203.843 233.654Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M208.281 220.453C205.96 222.71 204.731 225.857 203.229 228.593C203.092 228.866 203.297 229.14 203.57 229.208C203.57 229.277 203.639 229.345 203.707 229.277C206.779 228.729 210.26 227.088 212.582 224.967C214.015 223.668 215.244 221.205 213.537 219.564C211.899 217.991 209.578 219.153 208.281 220.453ZM211.216 219.974C215.176 219.906 212.582 223.805 211.421 224.694C210.738 225.309 209.919 225.788 209.1 226.267C207.462 227.293 205.687 228.045 203.98 228.866C204.799 227.567 205.482 226.199 206.233 224.831C207.257 223.257 209.032 219.974 211.216 219.974Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M255.384 188.032C255.384 188.032 298.461 176.13 321.193 179.413C343.448 182.628 351.982 210.877 329.863 225.583C305.697 241.657 216.268 233.723 216.268 233.723L236.201 199.865C236.201 199.865 266.853 193.367 294.706 194.324L255.453 199.66V188.032H255.384Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M234.836 202.054C234.836 201.985 234.836 201.917 234.904 201.849C234.904 201.78 234.904 201.78 234.973 201.712C234.973 201.575 235.041 201.507 235.041 201.37C235.109 201.165 235.177 200.959 235.246 200.686C235.314 200.481 235.451 200.275 235.519 200.07C235.655 199.865 235.792 199.66 235.86 199.455C235.86 199.455 235.928 199.455 235.928 199.386C235.928 199.386 235.928 199.386 235.997 199.386C235.997 199.386 235.997 199.386 236.065 199.386C236.065 199.386 236.065 199.386 236.133 199.386C239.478 198.771 262.416 195.487 265.829 195.077C269.243 194.667 272.724 194.393 276.137 194.051C283.032 193.504 289.927 193.162 296.822 193.299C297.437 193.299 298.119 193.367 298.734 193.367C298.87 193.299 299.007 193.299 299.143 193.23C299.485 193.162 299.826 193.093 300.167 193.025C300.782 192.888 301.396 192.82 302.011 192.751C303.308 192.546 304.605 192.409 305.902 192.136C305.97 192.136 306.038 192.273 305.902 192.273C304.605 192.546 303.308 192.957 302.011 193.23C301.601 193.299 301.26 193.367 300.85 193.504C303.376 193.641 305.902 193.846 308.428 194.051C308.496 194.051 308.496 194.188 308.428 194.188C305.014 193.983 301.533 193.983 298.119 194.051C294.706 194.119 291.293 194.188 287.879 194.393C280.984 194.803 274.089 195.419 267.195 196.103C263.372 196.513 239.956 199.933 236.065 200.07C236.065 200.07 236.065 200.07 235.997 200.07C235.997 200.139 235.928 200.275 235.86 200.344C235.724 200.549 235.655 200.754 235.519 200.959C235.382 201.165 235.314 201.37 235.177 201.575C235.109 201.643 235.041 201.78 234.973 201.849C234.973 201.917 234.904 201.917 234.904 201.985C234.904 202.054 234.836 202.054 234.836 202.122C234.904 202.191 234.768 202.122 234.836 202.054Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M223.367 231.671C224.596 229.687 225.62 227.567 226.781 225.515C227.941 223.463 229.033 221.411 230.194 219.359C232.447 215.255 240.57 201.575 241.39 200.617C241.458 200.549 241.526 200.617 241.526 200.686C241.117 201.78 236.065 210.809 234.904 212.861C232.583 216.896 230.126 220.864 227.668 224.899C226.985 226.062 226.234 227.156 225.552 228.319C224.869 229.482 224.118 230.576 223.435 231.739C223.435 231.808 223.367 231.739 223.367 231.671Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M281.462 144.05L278.39 144.256C278.185 143.435 277.912 142.682 277.503 141.998C275.932 139.262 273.202 137.21 270.949 135.158C272.997 137.21 275.045 139.878 276.342 142.546C276.615 143.093 276.82 143.708 276.888 144.256L274.977 144.392C274.635 142.614 273.953 140.972 272.86 139.468C272.86 139.399 272.792 139.468 272.792 139.536C273.748 141.041 274.158 142.682 274.294 144.392L257.569 145.35C257.159 143.914 256.818 142.477 256.613 140.972C256.613 140.836 256.34 140.836 256.34 141.041C256.545 142.546 256.75 143.982 257.091 145.418L255.726 145.487C255.248 143.024 254.975 140.562 255.179 137.894C255.179 137.826 255.043 137.826 255.043 137.894C254.77 140.357 254.702 143.024 255.043 145.555L243.438 146.239C243.984 144.598 244.257 142.819 244.53 141.109C244.53 140.972 244.325 140.972 244.325 141.109C244.052 142.956 243.438 144.666 242.823 146.308L241.116 146.376C242.14 143.435 242.755 140.425 242.687 137.279C242.687 137.142 242.482 137.142 242.482 137.279C242.414 140.63 241.048 143.503 239.683 146.444L235.314 146.718C236.543 144.05 238.932 141.451 238.932 138.373C238.932 134.953 235.587 133.654 234.29 130.918C232.174 126.335 234.222 122.504 237.02 118.948C239.546 115.664 238.864 112.244 239.137 108.346C239.342 105.473 239.819 102.258 241.116 99.6587C245.008 91.5875 253.609 91.8611 253.609 91.9295C255.657 91.7927 257.569 92.1347 259.344 93.0239C259.48 93.0923 259.548 93.1607 259.685 93.2291C261.596 94.2551 263.235 95.8283 264.668 97.9487C265.078 98.5643 265.488 99.1799 265.829 99.8639C266.443 101.095 266.716 102.805 267.399 104.72C267.399 104.789 267.399 104.789 267.467 104.857C268.355 107.593 269.993 110.74 274.158 113.27C279.141 116.28 278.527 122.026 275.455 127.976C274.158 130.507 274.294 132.012 275.045 133.312C275.182 133.448 275.25 133.654 275.386 133.79C276.479 135.158 278.254 136.253 279.551 138.1C280.779 139.81 281.326 141.93 281.462 144.05Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M246.373 93.7081C243.165 95.8285 240.912 98.9749 240.093 102.942C239.478 105.952 239.752 109.166 238.796 112.108C237.908 114.912 235.997 117.101 234.632 119.563C232.72 122.847 231.764 126.677 234.017 130.029C235.382 132.081 238.25 133.927 238.386 136.732C238.591 139.946 236.065 143.367 234.836 146.171C234.768 146.308 234.973 146.444 235.041 146.308C236.816 143.093 240.025 138.784 238.318 134.953C237.567 133.243 236.133 131.944 234.973 130.507C232.72 127.703 232.72 124.488 234.29 121.273C236.338 116.896 239.41 113.886 239.888 108.756C240.229 105.815 240.161 102.874 241.322 100.138C242.414 97.5385 244.257 95.4181 246.442 93.9133C246.578 93.8449 246.442 93.6397 246.373 93.7081Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M278.117 137.416C276.683 135.842 274.976 134.748 275.318 132.149C275.591 130.302 276.683 128.66 277.366 127.019C279.072 122.846 279.687 117.853 277.093 114.023C275.591 111.902 273.475 111.492 271.563 110.056C269.174 108.277 268.082 105.199 266.989 102.463C265.419 98.2907 263.576 93.5027 258.797 93.0239C258.729 93.0239 258.729 93.0923 258.797 93.0923C264.873 94.1183 265.692 101.369 268.013 106.225C268.764 107.867 269.788 109.44 271.222 110.534C273.475 112.244 276 112.655 277.366 115.528C278.663 118.195 278.663 121.342 277.912 124.283C277.298 126.814 275.796 129.002 275.181 131.533C274.84 133.038 274.908 134.543 275.796 135.774C276.478 136.732 277.571 137.347 278.322 138.305C279.346 139.536 279.823 141.109 279.96 142.751C279.96 142.888 280.233 142.888 280.165 142.682C280.096 140.562 279.414 138.852 278.117 137.416Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M242.346 130.37C225.894 145.76 210.739 162.587 209.647 171.068C208.213 182.765 215.449 185.911 218.658 185.843C227.396 185.774 242.619 149.933 247.944 136.253C252.996 123.052 245.965 127.019 242.346 130.37Z",
                  fill: "#F7A9A0"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M217.566 154.994L236.34 164.776C236.34 164.776 247.467 143.161 249.993 133.243C252.451 123.257 248.491 123.667 239.89 131.533C231.288 139.399 217.566 154.994 217.566 154.994Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M217.566 154.994L236.34 164.776C236.34 164.776 247.467 143.161 249.993 133.243C252.451 123.257 248.491 123.667 239.89 131.533C231.288 139.399 217.566 154.994 217.566 154.994Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M249.993 133.243C247.536 143.229 236.34 164.844 236.34 164.844L224.871 158.893L249.857 126.061C250.881 126.745 251.017 129.071 249.993 133.243Z",
                  fill: "#A6A6A6"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M221.322 152.121C228.558 156.841 235.589 159.85 237.023 160.671C237.091 160.74 237.16 160.603 237.091 160.534C235.658 159.85 227.944 155.199 221.458 151.984C221.322 151.916 221.253 152.053 221.322 152.121Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M236.407 161.492L230.059 187.074C230.059 187.074 255.727 192.409 285.969 187.826C285.969 187.826 276.548 140.972 265.148 128.524C259.413 122.299 252.723 122.778 248.422 127.087C247.33 128.182 235.998 143.708 234.701 150.206C233.472 155.952 236.407 161.492 236.407 161.492Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M256.205 159.919C253.406 160.125 250.675 160.398 247.944 161.014C246.579 161.287 245.282 161.698 243.917 162.04C243.234 162.245 242.62 162.382 241.937 162.587C241.254 162.792 240.503 162.929 239.821 162.929C239.752 162.929 239.752 162.997 239.821 162.997C240.503 163.066 241.186 163.066 241.869 162.997C242.551 162.929 243.166 162.861 243.848 162.724C245.214 162.45 246.579 162.108 247.944 161.766C250.743 161.151 253.474 160.535 256.273 160.125C256.341 160.125 256.341 159.919 256.205 159.919Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M262.962 162.656C260.709 162.314 258.388 162.108 256.067 162.108C254.907 162.108 253.746 162.108 252.654 162.177C252.108 162.245 251.562 162.245 251.016 162.314C250.401 162.382 249.787 162.519 249.241 162.587C249.172 162.587 249.172 162.724 249.241 162.656C249.787 162.656 250.401 162.724 250.947 162.724C251.493 162.724 252.108 162.724 252.654 162.724C253.815 162.724 254.975 162.792 256.067 162.792C258.388 162.792 260.641 162.792 262.962 162.929C263.099 162.792 263.099 162.656 262.962 162.656Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M265.625 128.387C282.555 139.057 300.851 158.141 302.216 170.043C303.513 181.739 296.823 181.192 295.731 180.987C283.648 178.387 266.513 147.129 260.096 134.338C253.679 121.547 261.461 125.719 265.625 128.387Z",
                  fill: "#F7A9A0"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M293.137 149.728L275.797 161.835C275.797 161.835 261.939 141.862 258.252 132.286C254.498 122.71 258.526 122.573 268.015 129.276C277.572 135.911 293.137 149.728 293.137 149.728Z",
                  fill: "#C7C7C7"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M289.04 147.266C282.418 152.874 275.864 156.773 274.567 157.731C274.499 157.799 274.431 157.662 274.499 157.662C275.796 156.773 282.896 151.233 288.971 147.197C289.04 147.129 289.108 147.197 289.04 147.266Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M276.889 160.946C276.752 160.946 276.001 161.424 275.797 161.561C273.68 158.21 274.09 158.962 271.974 155.679C270.95 154.037 269.926 152.396 268.833 150.754C267.741 149.044 266.785 147.266 265.625 145.624C265.557 145.556 265.557 145.624 265.557 145.692C266.308 147.334 267.263 148.907 268.151 150.412C267.946 150.207 267.809 149.933 267.605 149.728C267.127 149.249 266.717 148.702 266.308 148.155C266.239 148.086 266.103 148.155 266.171 148.223C266.581 148.77 266.922 149.249 267.263 149.796C267.605 150.344 268.014 150.891 268.424 151.37C268.833 151.848 269.243 152.327 269.653 152.806C269.721 152.874 269.721 152.943 269.789 153.011C270.335 153.969 270.95 154.995 271.496 155.952C273.612 159.304 275.66 161.903 275.728 161.903C275.933 161.835 276.889 161.082 276.957 161.014C277.025 161.014 276.957 160.946 276.889 160.946Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M268.013 129.208C268.013 129.208 257.364 137.005 250.947 136.321C244.53 135.569 241.936 129.618 241.936 129.618C241.936 129.618 249.513 122.231 257.5 123.872C262.279 124.898 268.013 129.208 268.013 129.208Z",
                  fill: "#F7A9A0"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M258.321 126.745C257.98 127.977 254.293 133.312 250.47 132.765C248.491 132.491 249.31 125.583 249.31 125.583L249.241 125.035L248.695 117.785L259.004 113.202C259.072 113.202 258.457 126.403 258.321 126.745Z",
                  fill: "#F7A9A0"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M258.867 118.127C256 123.052 251.426 124.557 249.31 125.035L248.764 117.785L259.072 113.202C259.072 113.202 259.004 115.459 258.867 118.127Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M238.796 108.346C239.137 121.137 246.783 122.368 249.514 122.3C252.04 122.231 260.505 121.684 261.529 108.962C262.553 96.2391 256.477 92.3403 250.811 92.2035C245.076 92.0667 238.455 95.5551 238.796 108.346Z",
                  fill: "#F7A9A0"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M242.209 105.61C242.483 105.541 242.756 105.473 243.097 105.405C243.438 105.336 243.711 105.268 243.916 104.994C244.053 104.857 244.053 104.584 243.916 104.447C243.643 104.105 243.165 104.105 242.824 104.242C242.414 104.31 242.073 104.515 241.8 104.857C241.459 105.199 241.8 105.678 242.209 105.61Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M250.402 105.131C250.129 105.131 249.856 105.063 249.514 104.994C249.173 104.926 248.9 104.926 248.627 104.721C248.49 104.584 248.49 104.31 248.559 104.173C248.832 103.831 249.241 103.763 249.651 103.831C250.06 103.9 250.402 104.037 250.743 104.31C251.084 104.652 250.811 105.131 250.402 105.131Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M248.967 108.482L249.035 108.551C249.035 109.44 249.24 110.398 250.059 110.671V110.74C249.104 110.671 248.899 109.303 248.967 108.482Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M249.719 107.525C251.084 107.32 251.357 110.124 250.128 110.329C248.831 110.466 248.558 107.662 249.719 107.525Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M250.263 107.662C250.537 107.799 250.81 108.072 251.083 108.072C251.424 108.072 251.629 107.73 251.834 107.457H251.902C251.97 108.004 251.834 108.551 251.219 108.688C250.673 108.825 250.263 108.346 250.127 107.867C250.127 107.73 250.195 107.593 250.263 107.662Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M243.985 108.756L243.917 108.825C243.985 109.714 243.917 110.672 243.166 111.014V111.082C244.19 110.877 244.258 109.577 243.985 108.756Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M243.166 107.867C241.732 107.867 241.8 110.672 243.097 110.672C244.394 110.74 244.394 107.936 243.166 107.867Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M242.619 108.072C242.414 108.209 242.209 108.483 241.936 108.551C241.663 108.551 241.39 108.278 241.185 108.004H241.117C241.117 108.551 241.322 109.098 241.8 109.167C242.278 109.235 242.619 108.756 242.756 108.278C242.756 108.209 242.687 108.004 242.619 108.072Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M249.854 115.391C249.718 115.665 249.581 116.007 249.308 116.075C249.035 116.212 248.626 116.212 248.353 116.144C248.353 116.144 248.284 116.212 248.353 116.212C248.694 116.486 249.172 116.486 249.581 116.28C249.923 116.075 249.991 115.733 249.991 115.323C249.923 115.323 249.854 115.323 249.854 115.391Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M245.623 112.655C245.623 112.655 245.555 113.954 245.623 114.57C245.623 114.638 247.535 114.844 248.695 113.27C248.763 113.202 248.627 113.134 248.627 113.202C247.876 113.886 246.988 114.091 246.033 114.16C245.964 114.023 246.237 111.902 246.101 111.902C245.76 111.902 245.145 112.176 244.736 112.313C244.804 109.577 245.282 106.909 245.282 104.173C245.282 104.105 245.145 104.036 245.145 104.173C244.394 106.978 244.326 110.124 244.189 112.928C244.189 113.339 245.418 112.792 245.623 112.655Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M246.441 114.433C246.441 114.433 247.056 115.117 247.807 115.254C248.08 115.323 248.353 115.323 248.694 115.186C249.309 114.981 249.24 114.365 249.104 113.886C248.967 113.476 248.762 113.134 248.762 113.134C248.762 113.134 247.875 114.16 246.441 114.433Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M247.807 115.254C248.08 115.323 248.353 115.323 248.694 115.186C249.308 114.981 249.24 114.365 249.104 113.886C248.421 114.091 247.807 114.639 247.807 115.254Z",
                  fill: "#FF98B9"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M260.709 109.782C258.388 110.329 257.227 104.926 257.227 104.926C257.227 104.926 246.919 104.242 245.212 96.0337C245.212 96.0337 243.983 101.506 238.932 104.379C238.932 104.379 238.386 95.2813 245.417 92.8189C245.417 92.8189 254.019 88.7149 259.685 95.2813C265.351 101.848 262.279 109.44 260.709 109.782Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M259.48 109.988C259.48 109.988 261.801 105.747 263.713 106.499C265.624 107.32 264.19 113.271 262.142 114.297C260.094 115.323 259.139 113.476 259.139 113.476L259.48 109.988Z",
                  fill: "#F7A9A0"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M263.303 108.209C263.303 108.209 263.303 108.277 263.303 108.209C261.938 109.03 261.255 110.466 260.914 111.971C261.324 111.355 261.87 111.013 262.621 111.424C262.689 111.424 262.621 111.492 262.621 111.492C262.006 111.424 261.597 111.561 261.255 112.108C260.982 112.518 260.846 112.929 260.709 113.339C260.641 113.476 260.436 113.407 260.436 113.271C260.436 113.271 260.436 113.271 260.436 113.202C260.095 111.424 261.255 108.619 263.303 108.209Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M261.87 113.886C261.801 114.16 261.528 114.365 261.255 114.365C260.982 114.297 260.777 114.023 260.777 113.749C260.846 113.476 261.119 113.271 261.392 113.271C261.733 113.271 261.938 113.544 261.87 113.886Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M245.145 95.418C245.145 96.7176 245.418 97.9488 245.964 99.18C246.51 100.343 247.261 101.437 248.217 102.326C248.421 102.532 248.694 102.737 248.967 102.942L249.377 103.216C249.514 103.284 249.65 103.352 249.787 103.489C250.06 103.626 250.333 103.831 250.606 103.968C250.879 104.105 251.22 104.242 251.493 104.31C251.63 104.378 251.766 104.447 251.971 104.515L252.449 104.652L253.405 104.926C254.019 105.062 254.702 105.131 255.316 105.199C254.702 104.994 254.087 104.857 253.473 104.652L252.586 104.31L252.176 104.173C252.039 104.105 251.903 104.036 251.766 103.968C251.493 103.831 251.22 103.694 250.947 103.558C250.674 103.421 250.401 103.216 250.196 103.079L249.787 102.805L249.445 102.532C249.241 102.326 248.967 102.19 248.763 101.916C247.807 101.095 247.124 100.069 246.51 98.9748C246.237 98.4276 245.964 97.8804 245.759 97.2648C245.418 96.6492 245.213 96.0336 245.145 95.418Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M219.203 185.774C224.665 185.09 227.941 174.967 234.222 158.893C235.314 156.089 221.524 139.604 219.545 142.204C217.087 145.487 208.008 163.134 207.12 166.212C204.253 175.651 212.786 186.595 219.203 185.774Z",
                  fill: "#F7A9A0"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M227.736 175.172C228.214 173.804 228.692 172.436 229.238 171.068C229.716 169.7 230.33 168.332 230.877 167.033C231.423 165.665 231.969 164.365 232.583 162.997C232.856 162.313 233.129 161.629 233.471 161.013C233.744 160.329 234.017 159.645 234.29 158.961C234.085 160.398 233.607 161.834 233.129 163.202C232.652 164.57 232.105 165.938 231.559 167.306C231.013 168.674 230.399 169.974 229.784 171.342C229.102 172.573 228.419 173.873 227.736 175.172Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M247.396 159.783C247.396 159.783 243.846 145.145 243.505 143.298C243.095 140.973 247.123 120.042 245.894 119.153C243.846 117.785 228.964 133.996 226.506 137.211C224.663 139.673 219.68 156.773 219.68 156.773L247.396 159.783Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("g", { attrs: { opacity: "0.1" } }, [
                _c("path", {
                  attrs: {
                    d:
                      "M247.396 159.783C247.396 159.783 243.846 145.145 243.505 143.298C243.095 140.973 247.123 120.042 245.894 119.153C243.846 117.785 228.964 133.996 226.506 137.211C224.663 139.673 219.68 156.773 219.68 156.773L247.396 159.783Z",
                    fill: "black"
                  }
                })
              ]),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M246.304 159.714C246.304 159.714 242.754 145.076 242.413 143.23C242.003 140.904 247.123 120.042 245.895 119.153C243.847 117.785 227.872 133.927 225.415 137.142C223.571 139.604 218.588 156.704 218.588 156.704L246.304 159.714Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M241.935 141.451C242.14 141.451 242.276 141.451 242.481 141.451C242.413 142.34 242.345 142.956 242.413 143.23C242.549 143.845 243.027 145.966 243.642 148.496C243.232 148.702 242.822 148.77 242.345 148.77C240.297 148.907 238.59 147.334 238.453 145.282C238.385 143.298 239.955 141.52 241.935 141.451Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M236.68 154.926C236.543 152.874 234.837 151.301 232.789 151.438C230.741 151.575 229.171 153.285 229.307 155.337C229.444 157.389 231.15 158.962 233.198 158.825C235.246 158.688 236.816 156.978 236.68 154.926Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M223.504 141.52C223.982 141.246 224.596 141.041 225.21 140.973C227.258 140.836 228.965 142.409 229.102 144.461C229.238 146.513 227.668 148.223 225.62 148.36C223.982 148.428 222.548 147.471 222.002 145.966C222.48 144.393 223.026 142.888 223.504 141.52Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M236.91 136.424C238.261 134.898 238.12 132.563 236.597 131.21C235.073 129.857 232.743 129.998 231.392 131.524C230.042 133.051 230.182 135.385 231.706 136.739C233.23 138.092 235.56 137.951 236.91 136.424Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M245.417 122.983C245.554 122.983 245.691 122.983 245.827 122.983C245.554 124.967 245.076 127.566 244.53 130.234C243.096 129.823 242.004 128.524 241.936 126.882C241.868 124.899 243.369 123.12 245.417 122.983Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M231.081 161.287C237.566 162.245 242.618 162.108 245.553 161.356C248.694 160.535 249.445 158.962 249.24 157.457C249.103 156.089 248.011 154.858 245.485 154.721C242.14 154.516 237.157 154.584 233.129 154.037C228.828 153.421 224.8 152.19 221.728 151.643C218.793 151.096 216.881 151.301 216.199 153.216C215.516 155.063 216.062 156.773 218.656 158.073C221.523 159.441 226.917 160.672 231.081 161.287Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  opacity: "0.2",
                  d:
                    "M231.081 161.287C237.566 162.245 242.618 162.108 245.553 161.356C248.694 160.535 249.445 158.962 249.24 157.457C249.103 156.089 248.011 154.858 245.485 154.721C242.14 154.516 237.157 154.584 233.129 154.037C228.828 153.421 224.8 152.19 221.728 151.643C218.793 151.096 216.881 151.301 216.199 153.216C215.516 155.063 216.062 156.773 218.656 158.073C221.523 159.441 226.917 160.672 231.081 161.287Z",
                  fill: "black"
                }
              }),
              _vm._v(" "),
              _c("g", { attrs: { opacity: "0.1" } }, [
                _c("path", {
                  attrs: {
                    d:
                      "M219.885 155.61C220.022 155.2 219.885 154.789 219.476 154.584C219.066 154.447 218.656 154.584 218.452 154.994C218.315 155.405 218.452 155.815 218.861 156.02C219.271 156.157 219.749 156.02 219.885 155.61Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M246.305 159.714C246.441 159.304 246.305 158.893 245.895 158.688C245.486 158.551 245.076 158.688 244.871 159.098C244.667 159.509 244.871 159.919 245.281 160.124C245.691 160.33 246.168 160.124 246.305 159.714Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M219.953 152.874C219.816 152.532 219.407 152.395 219.066 152.532C218.724 152.669 218.588 153.079 218.724 153.421C218.861 153.763 219.27 153.9 219.612 153.763C219.953 153.626 220.09 153.216 219.953 152.874Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M237.224 127.224C237.088 126.882 236.678 126.745 236.337 126.882C235.996 127.019 235.859 127.429 235.996 127.771C236.132 128.113 236.542 128.25 236.883 128.113C237.224 127.976 237.361 127.566 237.224 127.224Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M218.042 153.9C217.906 153.626 217.565 153.49 217.291 153.626C217.018 153.763 216.882 154.105 217.018 154.379C217.155 154.652 217.496 154.789 217.769 154.652C218.042 154.516 218.179 154.174 218.042 153.9Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M238.796 125.172C238.66 124.898 238.318 124.762 238.045 124.898C237.772 125.035 237.636 125.377 237.772 125.651C237.909 125.924 238.25 126.061 238.523 125.924C238.796 125.788 238.933 125.446 238.796 125.172Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M236.337 144.871C236.201 144.598 235.859 144.461 235.586 144.598C235.313 144.734 235.177 145.076 235.313 145.35C235.45 145.624 235.791 145.76 236.064 145.624C236.337 145.555 236.474 145.213 236.337 144.871Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M243.573 152.6C243.505 152.463 243.368 152.395 243.164 152.463C242.959 152.532 242.959 152.669 243.027 152.874C243.095 153.011 243.232 153.079 243.437 153.011C243.642 152.942 243.642 152.737 243.573 152.6Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M224.392 149.386C224.323 149.249 224.187 149.181 223.982 149.249C223.777 149.317 223.777 149.454 223.846 149.659C223.914 149.796 224.05 149.865 224.255 149.796C224.392 149.728 224.46 149.523 224.392 149.386Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M241.253 126.814C241.184 126.677 241.048 126.608 240.843 126.677C240.706 126.745 240.638 126.882 240.706 127.087C240.775 127.224 240.911 127.292 241.116 127.224C241.253 127.087 241.321 126.95 241.253 126.814Z",
                    fill: "black"
                  }
                })
              ]),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M218.657 135.911C219.339 133.859 221.251 133.927 221.251 133.927C221.251 133.927 219.612 131.875 220.636 129.96C221.114 128.934 223.162 128.934 223.162 128.934C223.162 128.934 221.933 127.224 222.889 125.582C223.708 124.283 225.62 124.419 225.62 124.419C225.62 124.419 225.21 122.231 226.439 121.136C228.965 118.879 240.98 124.488 240.843 129.755C240.775 132.217 237.908 130.712 237.908 130.712C237.908 130.712 241.526 133.859 240.434 136.389C239.341 138.92 235.723 136.731 235.723 136.731C235.723 136.731 239.205 139.809 237.84 142.34C236.406 144.939 233.197 142.135 233.197 142.135C233.197 142.135 235.041 145.213 233.539 146.855C231.081 149.591 227.873 143.229 224.937 142.614L221.456 146.307C221.387 146.239 217.974 138.168 218.657 135.911Z",
                  fill: "#F7A9A0"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M225.961 124.283C225.893 124.283 225.893 124.214 225.961 124.283C230.399 125.104 234.973 127.361 238.045 130.644C238.113 130.781 238.045 130.986 237.908 130.849C234.017 128.113 230.399 125.924 225.961 124.283Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M223.095 128.866C223.026 128.866 223.095 128.797 223.163 128.797C227.669 129.687 232.789 132.423 235.929 136.663C236.065 136.8 235.997 137.074 235.861 136.869C233.539 134.201 227.122 130.302 223.095 128.866Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M233.266 142.409C230.126 138.442 226.03 135.911 221.456 133.927C221.388 133.927 221.456 133.791 221.524 133.859C224.05 134.201 226.781 135.774 228.829 137.211C230.809 138.579 232.31 140.152 233.403 142.341C233.403 142.409 233.266 142.477 233.266 142.409Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M297.847 180.918C292.658 181.944 285.832 178.182 268.151 166.759C265.693 165.186 272.247 144.871 274.977 146.376C278.391 148.36 291.156 156.704 292.044 157.457C299.212 163.613 301.328 180.234 297.847 180.918Z",
                  fill: "#F7A9A0"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M281.327 152.053C281.327 152.053 276.138 145.487 272.315 142.956C267.195 139.468 261.393 138.647 258.935 138.373C253.815 137.895 241.049 140.357 241.117 144.119C241.186 147.539 254.088 144.393 254.088 144.393C254.088 144.393 240.435 145.419 241.254 149.523C242.073 153.627 256.819 149.181 256.819 149.181C256.819 149.181 242.824 150.549 244.326 154.653C245.487 157.799 259.072 154.447 259.072 154.447C259.072 154.447 247.057 155.679 248.081 158.962C249.241 162.587 262.007 160.261 262.007 160.261C266.035 168.059 271.155 170.179 274.978 171.205C275.865 171.547 281.327 152.053 281.327 152.053Z",
                  fill: "#F7A9A0"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M258.799 143.777C257.161 143.845 255.591 143.914 253.952 144.119C252.382 144.324 250.744 144.598 249.173 144.94C245.282 145.829 243.029 146.992 243.166 146.923C246.648 145.624 252.382 144.803 254.02 144.598C255.591 144.324 257.229 144.05 258.799 143.777C258.799 143.845 258.799 143.777 258.799 143.777Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M259.619 149.522C257.571 149.659 255.523 149.796 253.475 150.07C251.427 150.343 249.515 150.754 247.535 151.164C247.399 151.164 247.467 151.301 247.604 151.232C249.652 150.89 251.563 150.754 253.543 150.48C255.591 150.206 257.639 149.796 259.619 149.522C259.687 149.591 259.687 149.522 259.619 149.522Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M261.258 154.379C258.117 154.447 254.977 155.131 251.905 155.884C251.768 155.952 251.837 156.021 252.042 155.952C255.114 155.405 257.571 154.926 261.258 154.447C261.326 154.447 261.326 154.379 261.258 154.379Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M287.061 154.105C288.494 154.858 289.859 155.747 291.225 156.705C291.907 157.183 292.522 157.662 293.136 158.209C293.751 158.757 294.365 159.372 294.843 160.056C295.799 161.424 296.55 162.929 297.164 164.434C297.778 165.939 298.256 167.512 298.529 169.153C298.256 168.401 297.983 167.58 297.71 166.828C297.437 166.075 297.096 165.323 296.754 164.639C296.003 163.203 295.321 161.766 294.365 160.467C293.955 159.783 293.409 159.235 292.795 158.688C292.181 158.141 291.566 157.594 290.952 157.115C290.337 156.568 289.723 156.089 289.04 155.61L287.061 154.105Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M310.067 280.508C308.087 281.26 250.812 282.286 248.559 281.055C248.286 280.918 248.354 278.387 247.535 271.821C247.466 271.479 246.169 270.316 244.121 268.606C236.476 262.177 218.453 248.633 218.453 248.633L247.057 223.736L274.773 251.027L282.009 258.141C282.009 258.141 305.425 270.795 307.746 272.505C309.999 274.078 312.047 279.755 310.067 280.508Z",
                  fill: "#D3766A"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M310.068 280.508C308.088 281.26 250.812 282.286 248.559 281.055C248.286 280.918 248.355 278.388 247.535 271.821C247.467 271.479 246.17 270.316 244.122 268.606C241.46 266.349 240.163 265.323 236.203 262.245L272.521 248.839L274.706 250.959L281.942 258.073C281.942 258.073 305.357 270.727 307.678 272.437C309.999 274.078 312.047 279.756 310.068 280.508Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M314.027 281.329C312.047 282.013 251.017 282.697 248.764 281.329C248.218 280.987 247.74 277.43 247.399 272.573C247.33 271.958 241.186 267.033 240.299 266.075L277.709 253.421L282.419 257.867C282.419 257.867 309.931 270.727 312.184 272.437C314.505 274.283 316.007 280.645 314.027 281.329Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M313.139 279.071C303.582 278.934 260.984 279.345 251.495 279.96C251.426 279.96 251.426 280.029 251.495 280.029C260.984 280.371 303.514 279.618 313.139 279.208C313.344 279.208 313.344 279.071 313.139 279.071Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M285.492 258.346C281.737 257.662 277.095 258.346 274.228 261.014C274.091 261.151 274.296 261.287 274.364 261.219C278.05 259.988 281.532 259.235 285.423 258.757C285.765 258.825 285.765 258.415 285.492 258.346Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M288.222 259.988C284.467 259.304 279.825 259.988 276.958 262.655C276.822 262.792 277.026 262.929 277.095 262.861C280.781 261.629 284.263 260.877 288.154 260.398C288.495 260.398 288.495 259.988 288.222 259.988Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M291.021 261.561C287.266 260.877 282.624 261.561 279.757 264.228C279.62 264.365 279.825 264.502 279.893 264.433C283.58 263.202 287.061 262.45 290.953 261.971C291.226 262.039 291.294 261.629 291.021 261.561Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M293.753 263.202C289.999 262.518 285.356 263.202 282.489 265.87C282.353 266.007 282.558 266.143 282.626 266.075C286.312 264.844 289.794 264.091 293.685 263.613C294.026 263.613 294.026 263.271 293.753 263.202Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M292.387 249.522C290.885 247.47 288.154 248.428 286.584 249.796C284.058 251.985 281.874 255.336 280.85 258.551C280.85 258.62 280.85 258.688 280.918 258.688C280.918 258.962 281.191 259.304 281.532 259.167C284.604 258.004 288.086 257.115 290.748 254.994C292.318 253.695 293.82 251.438 292.387 249.522ZM285.901 256.362C284.399 256.978 282.829 257.525 281.396 258.209C282.488 256.499 283.58 254.789 284.809 253.216C285.423 252.464 286.038 251.711 286.789 251.027C287.881 250.001 292.318 247.744 291.704 251.916C291.363 254.174 287.676 255.61 285.901 256.362Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M271.224 257.662C274.365 258.962 277.915 258.825 281.26 259.098C281.601 259.098 281.738 258.756 281.738 258.483C281.806 258.483 281.806 258.415 281.806 258.346C279.963 255.61 276.959 252.942 273.887 251.574C272.044 250.685 269.108 250.548 268.221 252.942C267.333 255.131 269.45 256.91 271.224 257.662ZM269.518 254.994C267.743 251.164 272.658 252.053 274.023 252.806C274.911 253.216 275.73 253.832 276.549 254.379C278.256 255.542 279.69 256.91 281.26 258.278C279.621 258.073 278.051 257.936 276.413 257.73C274.365 257.457 270.474 257.115 269.518 254.994Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M275.183 249.454L239.82 267.786C239.82 267.786 203.025 234.406 199.611 234.133C196.335 233.928 146.705 267.58 121.787 267.649C95.9826 267.786 94.6855 240.631 94.6855 240.631L132.369 231.944C159.539 218.538 187.801 194.461 206.302 196.718C226.372 199.249 275.183 249.454 275.183 249.454Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M266.513 244.803C260.573 247.745 262.212 246.855 256.273 249.865C253.337 251.37 238.728 258.757 236.27 260.535C236.202 260.604 236.27 260.672 236.339 260.672C239.274 259.715 253.678 251.985 256.614 250.481C262.485 247.334 260.778 248.223 266.649 245.009C266.717 244.872 266.649 244.735 266.513 244.803Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M233.54 259.372C226.645 253.285 203.98 233.38 203.093 232.628C202.342 232.012 201.591 231.26 200.704 230.85C199.953 230.508 199.202 230.713 198.519 231.055C197.495 231.534 196.471 232.081 195.379 232.56C193.331 233.586 191.283 234.543 189.235 235.569C181.316 239.468 173.465 243.435 165.478 247.129C157.832 250.754 152.303 254.106 144.315 256.91C136.328 259.646 128.136 261.766 119.739 262.792C118.715 262.929 117.691 262.998 116.667 263.134C116.599 263.134 116.599 263.271 116.667 263.271C124.928 262.861 132.983 261.151 140.834 258.757C148.753 256.294 154.146 253.148 161.723 249.66C169.506 246.034 177.22 242.204 184.934 238.374C189.03 236.322 193.058 234.338 197.154 232.286C198.11 231.807 199.407 230.85 200.431 231.328C200.908 231.534 201.25 231.944 201.659 232.218C202.137 232.628 202.547 232.97 203.025 233.38C204.8 234.817 232.516 258.757 233.403 259.509C233.54 259.509 233.608 259.441 233.54 259.372Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M94.6171 240.7C94.6171 240.7 90.3845 265.187 102.604 274.831C114.824 284.476 204.322 283.313 217.907 278.867C231.492 274.489 231.901 252.533 217.087 247.403C202.956 242.546 142.882 240.221 141.38 239.605C141.038 239.468 146.705 236.048 146.705 235.843L133.051 231.671L94.6171 240.7Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M113.117 240.084C113.117 239.947 112.912 240.015 112.912 240.084C112.912 242.82 111.888 245.761 110.113 247.881C108.065 250.275 104.993 251.643 102.194 253.011C101.921 253.148 102.126 253.559 102.399 253.49C104.106 253.011 105.744 252.259 107.314 251.37C108.748 250.549 110.045 249.591 111.001 248.292C112.844 245.966 113.595 243.025 113.117 240.084Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M140.356 237.074C139.741 236.253 139.059 235.501 138.444 234.749C136.942 232.902 135.372 231.123 133.802 229.345C133.666 229.208 133.324 229.413 133.461 229.619C134.553 231.055 135.714 232.423 136.806 233.791C137.352 234.475 137.966 235.227 138.512 235.911C139.059 236.595 139.741 237.211 140.151 237.963C140.561 238.716 140.014 239.4 139.195 239.537C138.444 239.605 137.83 239.263 137.215 238.784C135.918 237.827 134.963 236.39 133.87 235.227C133.256 234.475 132.573 233.791 131.959 233.039C131.276 232.286 130.525 231.534 129.843 230.781C129.774 230.713 129.706 230.781 129.774 230.85C130.389 231.671 130.935 232.56 131.549 233.381C132.164 234.201 132.778 235.022 133.392 235.843C134.007 236.595 134.621 237.348 135.236 238.1C135.782 238.716 136.396 239.331 137.079 239.742C138.239 240.426 140.287 240.563 140.902 239.058C141.243 238.374 140.834 237.621 140.356 237.074Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M215.995 278.935C211.353 279.004 206.643 279.277 202.001 279.414C197.359 279.482 192.716 279.551 188.074 279.482C178.79 279.414 169.437 279.004 160.153 278.388C150.732 277.704 140.629 276.815 131.276 275.515C126.839 274.9 122.265 274.352 117.896 273.395C113.937 272.506 110.319 270.864 107.315 267.991C101.239 262.109 98.918 253.49 97.9622 245.214C97.8257 244.12 97.7574 243.025 97.6209 241.862C97.6209 241.794 97.4844 241.794 97.4844 241.862C98.0305 250.344 99.3276 259.168 104.652 265.939C106.973 268.88 109.841 271.274 113.322 272.642C117.487 274.352 122.129 274.694 126.566 275.31C135.919 276.61 146.09 277.567 155.511 278.32C165 279.072 174.489 279.482 183.978 279.688C193.467 279.824 203.025 279.688 212.514 279.209C213.674 279.14 214.835 279.072 215.995 279.004C216.064 279.072 216.064 278.935 215.995 278.935Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M186.571 242.957C183.636 242.546 180.7 242.067 177.697 241.794C174.693 241.452 171.689 241.247 168.754 240.973C162.815 240.494 156.875 240.015 150.936 239.742C147.591 239.605 144.178 239.537 140.833 239.605C140.696 239.605 140.764 239.742 140.833 239.742C146.772 240.289 152.711 240.631 158.65 241.041C164.59 241.452 170.529 241.931 176.4 242.546C179.745 242.888 183.09 243.093 186.503 243.367C186.708 243.435 186.776 242.957 186.571 242.957Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M147.387 235.569C144.998 236.527 142.745 237.827 140.561 239.195C138.376 240.563 136.192 241.999 134.28 243.641C134.212 243.709 134.28 243.777 134.349 243.709C136.67 242.615 138.854 241.315 141.107 240.015C143.291 238.716 145.544 237.416 147.592 235.843C147.66 235.775 147.592 235.501 147.387 235.569Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M123.835 192.409C131.072 203.558 143.565 217.17 149.982 215.665C158.174 213.682 166.093 181.123 167.185 180.302C169.779 178.25 153.258 162.724 150.459 164.844C146.09 167.99 142.267 191.794 140.561 191.725C138.854 191.657 133.871 187.142 126.976 183.312C118.306 178.456 118.442 184.064 123.835 192.409Z",
                  fill: "#D3766A"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M166.23 180.234C168.141 178.866 176.879 171.205 178.722 168.674C180.565 166.212 185.412 158.619 183.706 156.978C181.931 155.336 180.361 157.457 180.361 157.457C180.361 157.457 181.931 153.968 180.019 152.463C178.108 150.959 175.719 154.31 175.719 154.31C175.719 154.31 177.016 150.617 175.036 149.249C172.988 147.881 171.213 151.711 171.213 151.711C171.213 151.711 172.578 148.359 170.462 147.949C167.936 147.47 166.093 153.968 163.84 156.499C163.294 157.115 152.576 167.717 152.576 167.717L166.23 180.234Z",
                  fill: "#D3766A"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M171.281 151.437C169.916 156.157 168.482 158.004 164.864 161.287C164.796 161.355 164.864 161.492 164.932 161.424C168.755 158.551 170.872 156.499 171.486 151.506C171.554 151.232 171.35 151.232 171.281 151.437Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M175.786 154.037C173.943 158.825 172.441 160.877 168.892 164.502C168.823 164.57 168.892 164.639 168.96 164.57C172.714 161.287 174.762 159.167 175.991 154.105C176.06 153.9 175.855 153.763 175.786 154.037Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M180.155 157.661C178.039 162.176 176.469 164.501 172.578 167.579C172.509 167.648 172.578 167.785 172.714 167.716C177.015 164.912 178.995 162.107 180.292 157.73C180.36 157.456 180.292 157.388 180.155 157.661Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M192.851 159.577C192.851 159.577 180.154 166.622 178.584 167.511C176.672 168.674 164.384 185.295 162.951 184.953C160.63 184.406 162.473 163.134 163.155 159.303C163.702 156.362 172.644 141.656 172.644 141.656L192.851 159.577Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("g", { attrs: { opacity: "0.1" } }, [
                _c("path", {
                  attrs: {
                    d:
                      "M192.851 159.577C192.851 159.577 180.154 166.622 178.584 167.511C176.672 168.674 164.384 185.295 162.951 184.953C160.63 184.406 162.473 163.134 163.155 159.303C163.702 156.362 172.644 141.656 172.644 141.656L192.851 159.577Z",
                    fill: "black"
                  }
                })
              ]),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M192.101 158.825C192.101 158.825 179.404 165.87 177.834 166.759C175.922 167.922 164.385 185.295 162.951 184.885C160.63 184.338 161.723 162.313 162.405 158.483C162.951 155.541 171.894 140.835 171.894 140.835L192.101 158.825Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M176.263 167.58C176.399 167.716 176.468 167.853 176.604 167.922C177.15 167.306 177.628 166.896 177.833 166.69C178.379 166.348 180.154 165.322 182.339 164.091C182.202 163.681 181.997 163.339 181.724 162.997C180.495 161.492 178.243 161.218 176.672 162.518C175.239 163.818 174.966 166.075 176.263 167.58Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M182.407 155.063C180.906 156.294 178.653 156.089 177.356 154.584C176.127 153.079 176.332 150.822 177.834 149.522C179.335 148.291 181.588 148.496 182.885 150.001C184.114 151.574 183.909 153.832 182.407 155.063Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M164.248 154.379C164.385 154.926 164.589 155.473 164.999 155.883C166.228 157.388 168.481 157.662 170.051 156.362C171.553 155.131 171.826 152.874 170.529 151.301C169.505 150.069 167.866 149.659 166.433 150.275C165.613 151.711 164.862 153.147 164.248 154.379Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M168.072 169.632C166.57 170.863 164.317 170.658 163.02 169.153C161.791 167.648 161.996 165.391 163.498 164.092C165 162.86 167.252 163.066 168.549 164.57C169.846 166.144 169.642 168.401 168.072 169.632Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M165.41 182.081C165.478 182.149 165.614 182.286 165.683 182.355C166.911 180.85 168.482 178.798 169.983 176.746C168.755 175.993 167.116 176.062 165.887 177.019C164.386 178.319 164.112 180.576 165.41 182.081Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M183.227 146.923C188.142 150.89 191.351 154.652 192.716 157.251C194.15 160.056 193.535 161.561 192.375 162.45C191.283 163.271 189.781 163.271 188.006 161.561C185.685 159.303 182.476 155.747 179.404 153.147C176.196 150.48 172.646 148.359 170.256 146.581C168.004 144.803 166.843 143.366 167.731 141.656C168.618 139.946 170.12 139.262 172.782 140.288C175.718 141.246 180.087 144.324 183.227 146.923Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  opacity: "0.2",
                  d:
                    "M183.227 146.923C188.142 150.89 191.351 154.652 192.716 157.251C194.15 160.056 193.535 161.561 192.375 162.45C191.283 163.271 189.781 163.271 188.006 161.561C185.685 159.303 182.476 155.747 179.404 153.147C176.196 150.48 172.646 148.359 170.256 146.581C168.004 144.803 166.843 143.366 167.731 141.656C168.618 139.946 170.12 139.262 172.782 140.288C175.718 141.246 180.087 144.324 183.227 146.923Z",
                  fill: "black"
                }
              }),
              _vm._v(" "),
              _c("g", { attrs: { opacity: "0.1" } }, [
                _c("path", {
                  attrs: {
                    d:
                      "M171.963 142.614C171.758 142.956 171.348 143.161 170.939 142.956C170.597 142.751 170.393 142.34 170.597 141.93C170.802 141.588 171.212 141.383 171.621 141.588C171.963 141.793 172.099 142.203 171.963 142.614Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M192.101 158.825C191.897 159.167 191.487 159.372 191.077 159.167C190.736 158.961 190.531 158.551 190.736 158.141C190.941 157.799 191.35 157.593 191.76 157.799C192.101 158.004 192.238 158.414 192.101 158.825Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M169.983 144.392C169.642 144.529 169.3 144.324 169.164 143.982C169.027 143.64 169.232 143.298 169.573 143.161C169.915 143.024 170.256 143.229 170.393 143.571C170.529 143.913 170.324 144.324 169.983 144.392Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M163.089 173.462C162.747 173.599 162.406 173.394 162.269 173.052C162.133 172.71 162.338 172.368 162.679 172.231C163.02 172.094 163.362 172.299 163.498 172.641C163.566 172.983 163.43 173.394 163.089 173.462Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M169.505 142.409C169.232 142.477 168.89 142.34 168.822 142.067C168.754 141.793 168.89 141.451 169.163 141.383C169.436 141.314 169.778 141.451 169.846 141.725C169.983 141.998 169.778 142.34 169.505 142.409Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M162.61 175.925C162.337 175.993 161.996 175.856 161.928 175.583C161.859 175.309 161.996 174.967 162.269 174.899C162.542 174.83 162.883 174.967 162.952 175.241C163.088 175.583 162.883 175.856 162.61 175.925Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M175.034 161.355C174.761 161.424 174.42 161.287 174.351 161.013C174.283 160.74 174.42 160.398 174.693 160.329C174.966 160.261 175.307 160.398 175.375 160.671C175.512 160.945 175.307 161.219 175.034 161.355Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M185.207 161.424C185.071 161.492 184.934 161.355 184.866 161.219C184.798 161.082 184.934 160.945 185.071 160.877C185.207 160.808 185.344 160.945 185.412 161.082C185.48 161.219 185.412 161.424 185.207 161.424Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M170.461 149.864C170.325 149.933 170.188 149.796 170.12 149.659C170.051 149.522 170.188 149.385 170.325 149.317C170.461 149.249 170.598 149.385 170.666 149.522C170.666 149.659 170.598 149.796 170.461 149.864Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M165.34 176.609C165.203 176.677 165.067 176.54 164.999 176.404C164.93 176.267 165.067 176.13 165.203 176.062C165.34 175.993 165.476 176.13 165.545 176.267C165.613 176.404 165.476 176.609 165.34 176.609Z",
                    fill: "black"
                  }
                })
              ]),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M147.865 169.29C147.865 169.29 149.299 163.749 152.576 160.261C154.487 158.277 163.84 152.463 165.205 154.515C166.912 157.114 162.065 161.424 159.402 163.202C159.402 163.202 163.362 169.153 160.563 172.983C157.696 176.882 147.865 169.29 147.865 169.29Z",
                  fill: "#D3766A"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M165.41 155.404C165.273 158.893 161.655 161.013 159.198 162.997C158.993 163.134 159.061 163.339 159.198 163.475C160.699 166.075 162.065 170.179 160.699 173.051C160.631 173.12 160.768 173.188 160.836 173.12C162.679 170.247 161.723 166.075 159.88 163.339C162.406 161.355 165.956 159.029 165.41 155.404Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M141.175 190.699L129.16 201.917C129.16 201.917 123.084 193.503 120.081 188.715C116.121 182.423 117.759 178.934 126.293 182.081C132.027 184.133 141.175 190.699 141.175 190.699Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M138.786 189.536C136.943 191.041 135.168 192.614 133.529 194.256C132.71 195.077 131.823 195.897 131.072 196.787C130.252 197.607 129.57 198.565 128.751 199.454C128.682 199.523 128.819 199.591 128.819 199.523C129.57 198.633 130.525 197.881 131.345 197.06C132.164 196.239 132.983 195.419 133.871 194.598C135.577 192.956 137.216 191.315 138.991 189.673C138.922 189.605 138.854 189.468 138.786 189.536Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  opacity: "0.1",
                  d:
                    "M136.601 194.94L129.092 201.916C129.092 201.916 123.016 193.503 120.013 188.715C118.238 185.979 117.623 183.722 118.169 182.354L136.601 194.94Z",
                  fill: "black"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M145.408 235.091L93.457 245.282C93.3888 244.188 96.9386 211.903 101.239 199.659C106.769 183.927 110.387 182.354 112.503 181.26C115.234 179.892 120.354 179.823 121.651 180.302C123.085 180.781 128.273 187.895 130.526 193.298C134.963 204.174 146.022 234.338 145.408 235.091Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M113.937 229.413C114.21 229.961 114.62 230.371 115.03 230.781C115.439 231.123 115.917 231.465 116.531 231.671C116.258 231.123 115.849 230.713 115.439 230.303C115.03 229.961 114.552 229.619 113.937 229.413ZM123.631 188.237C123.904 188.784 124.314 189.194 124.723 189.605C125.133 189.947 125.611 190.289 126.225 190.494C125.952 189.947 125.543 189.536 125.133 189.126C124.655 188.715 124.246 188.442 123.631 188.237ZM138.582 222.779C138.855 223.326 139.264 223.736 139.674 224.147C140.083 224.489 140.561 224.831 141.176 225.036C140.903 224.489 140.493 224.078 140.083 223.668C139.606 223.326 139.128 222.984 138.582 222.779ZM100.147 213.339C100.694 213.066 101.103 212.655 101.513 212.245C101.854 211.766 102.195 211.356 102.4 210.74C101.854 211.014 101.445 211.424 101.035 211.835C100.625 212.245 100.352 212.724 100.147 213.339ZM108.749 192.546C109.295 192.272 109.705 191.862 110.114 191.451C110.456 191.041 110.797 190.562 111.002 189.947C110.456 190.22 110.046 190.631 109.637 191.041C109.227 191.451 108.886 191.93 108.749 192.546ZM137.148 236.048C137.694 235.775 138.104 235.364 138.513 234.954C138.855 234.543 139.196 234.065 139.401 233.449C138.855 233.723 138.445 234.133 138.035 234.543C137.694 235.022 137.353 235.501 137.148 236.048ZM121.447 210.945C121.993 210.672 122.402 210.261 122.812 209.851C123.153 209.441 123.495 208.962 123.699 208.346C123.153 208.62 122.744 209.03 122.334 209.441C121.925 209.919 121.583 210.398 121.447 210.945ZM101.991 237.621C102.605 237.827 103.151 237.827 103.766 237.827C104.312 237.758 104.926 237.69 105.472 237.416C104.858 237.211 104.312 237.211 103.766 237.279C103.151 237.211 102.537 237.348 101.991 237.621ZM110.729 216.417C111.343 216.623 111.889 216.623 112.435 216.554C112.982 216.486 113.596 216.417 114.142 216.144C113.528 215.939 112.982 215.939 112.435 215.939C111.821 216.075 111.275 216.144 110.729 216.417ZM134.008 211.835C134.622 212.04 135.168 212.04 135.714 211.971C136.261 211.903 136.875 211.835 137.421 211.561C136.807 211.356 136.261 211.356 135.714 211.356C135.168 211.424 134.554 211.561 134.008 211.835ZM124.041 235.569C124.655 235.775 125.201 235.775 125.747 235.706C126.294 235.638 126.908 235.569 127.454 235.296C126.84 235.091 126.294 235.091 125.747 235.091C125.201 235.227 124.587 235.296 124.041 235.569ZM100.898 200.891C101.308 200.822 101.718 200.685 102.059 200.549C101.718 200.412 101.376 200.412 101.035 200.343C100.967 200.549 100.898 200.754 100.898 200.891ZM119.33 197.539C119.945 197.744 120.491 197.744 121.037 197.676C121.583 197.607 122.198 197.539 122.744 197.265C122.129 197.06 121.583 197.06 121.037 197.06C120.491 197.129 119.945 197.265 119.33 197.539ZM115.098 181.328C115.166 181.875 115.234 182.491 115.507 183.038C115.712 182.423 115.712 181.875 115.644 181.26C115.644 180.986 115.576 180.713 115.507 180.371C115.371 180.371 115.166 180.439 115.03 180.439C115.098 180.781 115.098 181.055 115.098 181.328ZM127.249 223.189C127.318 223.736 127.386 224.352 127.659 224.899C127.864 224.283 127.864 223.736 127.795 223.189C127.727 222.642 127.659 222.026 127.386 221.479C127.249 222.026 127.249 222.642 127.249 223.189ZM102.127 224.489C102.195 225.036 102.264 225.651 102.537 226.199C102.742 225.583 102.742 225.036 102.742 224.489C102.673 223.941 102.605 223.326 102.332 222.779C102.059 223.326 102.059 223.941 102.127 224.489ZM132.711 200.685C132.779 201.233 132.847 201.848 133.12 202.395C133.325 201.78 133.325 201.233 133.257 200.685C133.257 200.549 133.257 200.412 133.189 200.275C133.052 199.933 132.915 199.523 132.779 199.181C132.711 199.659 132.711 200.138 132.711 200.685ZM110.524 204.174C110.592 204.721 110.661 205.337 110.934 205.884C111.138 205.268 111.138 204.721 111.07 204.174C111.002 203.627 110.934 203.011 110.661 202.464C110.524 203.011 110.524 203.558 110.524 204.174Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M108.476 184.817C91.3406 202.669 66.4232 247.882 63.283 254.38C61.1667 258.757 84.1726 270.385 85.1283 267.17C86.3571 263.066 106.359 212.45 111.684 193.367C114.688 182.833 112.025 181.123 108.476 184.817Z",
                  fill: "#D3766A"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M86.2207 264.161C85.4015 266.349 82.6708 275.652 80.7593 276.815C78.8479 277.977 68.8127 277.704 63.8292 277.704C58.7775 277.704 57.8217 276.267 57.89 274.557C57.9583 272.847 68.5396 272.505 68.5396 272.505C68.5396 272.505 54.4084 276.541 50.8585 277.225C47.3087 277.909 39.1167 279.961 37.9561 277.02C37.41 275.72 39.6628 274.352 39.6628 274.352C39.6628 274.352 36.2495 275.378 35.7033 273.668C35.0889 271.753 37.8196 270.659 37.8196 270.659C37.8196 270.659 35.7033 271.069 35.6351 269.496C35.4985 265.939 48.9471 264.229 48.9471 264.229C48.9471 264.229 38.6388 269.222 38.2975 266.349C37.8196 262.314 58.914 257.936 61.1668 256.226C63.3513 254.448 64.7167 251.849 64.7167 251.849L86.2207 264.161Z",
                  fill: "#D3766A"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M57.958 275.447C57.8897 274.899 58.0945 274.421 58.4358 274.079C58.7772 273.737 59.1868 273.463 59.6646 273.258C60.5521 272.847 61.5761 272.574 62.5318 272.3C64.5116 271.821 66.5596 271.411 68.6076 270.932C66.4913 270.932 64.4433 271.137 62.3953 271.616C61.3713 271.89 60.3473 272.232 59.3916 272.779C58.9137 273.053 58.5041 273.395 58.1628 273.873C57.8214 274.352 57.7532 274.968 57.958 275.447Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M39.6621 274.352C41.0957 274.01 42.5293 273.6 43.9629 273.189C45.3965 272.779 46.8301 272.369 48.2637 271.89L52.4962 270.522C53.9298 270.043 55.3634 269.633 56.797 269.222C55.2952 269.359 53.8616 269.701 52.3597 270.043C50.9261 270.385 49.4925 270.795 48.0589 271.206C46.6253 271.685 45.1917 272.095 43.8264 272.642C42.3928 273.189 41.0274 273.737 39.6621 274.352Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M53.384 265.666C52.0187 265.734 50.6534 265.939 49.288 266.213C47.9227 266.486 46.6256 266.828 45.3286 267.239C44.0315 267.649 42.7344 268.128 41.4374 268.675C40.2086 269.222 38.9798 269.838 37.751 270.59C39.048 270.112 40.3451 269.633 41.6422 269.222C42.9392 268.812 44.2363 268.333 45.5334 267.923C46.8304 267.512 48.1275 267.102 49.4246 266.76C50.7216 266.418 52.0187 266.076 53.384 265.666Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M51.2673 262.314C49.0145 262.451 46.8982 262.998 44.782 263.682C42.6657 264.434 40.6177 265.324 38.8428 266.555C40.959 265.802 42.9388 265.05 45.055 264.298C47.103 263.614 49.151 262.998 51.2673 262.314Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M90.5215 204.105L110.524 204.789C110.524 204.789 113.254 195.077 114.005 189.536C115.029 182.149 112.503 180.029 105.677 186.048C101.035 190.015 90.5215 204.105 90.5215 204.105Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M108.066 204.721C108.271 204.721 110.319 204.721 110.456 204.721C110.729 203.558 111.002 202.395 111.343 201.301C111.48 200.754 111.684 200.138 111.821 199.591C112.026 198.975 112.162 198.223 112.367 197.676C112.367 197.607 112.504 197.607 112.504 197.676C112.367 198.428 112.231 198.975 112.094 199.591C111.958 200.138 111.821 200.754 111.684 201.301C111.411 202.464 111.138 203.763 110.729 204.995C110.729 205.063 108.203 204.789 107.998 204.789C107.998 204.789 107.998 204.721 108.066 204.721Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M92.5698 202.259C95.5052 202.19 98.3724 202.122 101.308 202.19C102.741 202.259 104.243 202.259 105.677 202.396C107.111 202.464 108.544 202.738 110.046 202.738C110.114 202.738 110.114 202.874 110.046 202.874C108.612 202.738 107.111 202.806 105.677 202.738C104.243 202.669 102.741 202.601 101.308 202.601C98.3724 202.532 95.5052 202.464 92.5698 202.396C92.5015 202.396 92.5015 202.259 92.5698 202.259Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M122.538 191.041C119.535 191.793 114.278 187.279 112.162 183.585C112.025 183.312 112.367 180.644 112.64 177.293C112.776 175.309 112.913 173.052 112.845 171C112.845 170.589 125.747 173.873 125.747 173.873C125.747 173.873 124.586 178.182 124.655 181.739C124.655 182.012 124.723 182.286 124.791 182.559C124.791 182.628 124.791 182.628 124.791 182.696C125.133 184.406 125.474 190.289 122.538 191.041Z",
                  fill: "#D3766A"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M113.664 171.068C114.347 174.557 116.6 182.833 123.494 182.902C123.972 182.902 124.382 182.902 124.792 182.833C124.792 182.765 124.792 182.765 124.792 182.696C124.723 182.423 124.723 182.149 124.655 181.876C124.587 178.319 125.747 174.01 125.747 174.01C125.747 174.01 116.463 171.547 113.664 171.068Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M109.5 157.593C108.749 162.313 112.913 175.035 116.531 177.498C121.788 181.054 129.434 180.439 132.233 174.351C134.963 168.469 129.229 151.984 125.269 149.796C119.467 146.649 110.66 150.616 109.5 157.593Z",
                  fill: "#D3766A"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M120.285 161.424C120.695 161.287 120.968 161.082 121.378 160.877C121.787 160.671 122.129 160.535 122.333 160.124C122.47 159.919 122.333 159.509 122.129 159.372C121.651 159.03 121.105 159.167 120.558 159.44C120.012 159.714 119.671 160.056 119.398 160.603C119.193 161.082 119.808 161.629 120.285 161.424Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M129.296 158.688C128.887 158.756 128.477 158.756 128.136 158.756C127.658 158.756 127.317 158.825 126.907 158.62C126.702 158.483 126.634 158.141 126.702 157.867C126.975 157.32 127.522 157.183 128.068 157.115C128.682 157.046 129.16 157.183 129.638 157.525C130.047 157.867 129.774 158.62 129.296 158.688Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M124.518 172.231C124.791 172.368 125.065 172.573 125.406 172.505C125.679 172.436 126.02 172.163 126.225 171.958H126.293C126.157 172.368 125.747 172.71 125.338 172.778C124.928 172.847 124.655 172.573 124.45 172.231C124.382 172.231 124.45 172.231 124.518 172.231Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M124.586 169.358C125.337 169.974 126.156 170.111 126.975 170.042C127.316 169.974 127.726 169.905 128.067 169.769C128.136 169.769 128.204 169.7 128.272 169.7C128.34 169.7 128.409 169.632 128.477 169.632C128.545 169.563 128.613 169.495 128.613 169.358C128.613 169.358 128.613 169.29 128.545 169.29V169.221C128.34 168.537 127.931 167.58 127.931 167.58C128.204 167.648 129.637 167.785 129.501 167.443C128.409 164.639 127.18 161.492 125.541 158.961C125.473 158.893 125.337 158.961 125.405 159.03C126.361 161.766 127.726 164.297 128.75 167.033C128.34 167.033 127.589 166.964 127.248 167.033C127.18 167.101 127.999 168.948 128.067 169.221C126.975 169.7 126.088 169.632 124.722 169.29C124.517 169.221 124.517 169.358 124.586 169.358Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M127.522 169.564C127.522 169.564 127.181 170.521 126.498 171.068C126.225 171.274 125.952 171.41 125.542 171.41C124.791 171.479 124.586 170.795 124.518 170.248C124.45 169.769 124.586 169.358 124.586 169.358C124.586 169.358 125.883 169.974 127.522 169.564Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M126.498 171.068C126.225 171.274 125.952 171.41 125.543 171.41C124.792 171.479 124.587 170.795 124.519 170.248C125.269 170.111 126.157 170.384 126.498 171.068Z",
                  fill: "#FF98B9"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M129.911 161.629C129.774 161.424 129.638 161.287 129.433 161.15C129.228 161.013 128.955 161.082 128.682 161.15C128.477 161.219 128.272 161.492 128.204 161.766C128.136 161.971 128.204 162.245 128.204 162.45C128.272 162.587 128.272 162.723 128.341 162.86C128.477 163.134 128.614 163.339 128.819 163.544C128.75 163.339 128.682 163.134 128.614 162.997C128.545 162.792 128.546 162.655 128.546 162.45C128.477 162.108 128.614 161.697 128.819 161.629C129.092 161.492 129.365 161.629 129.638 161.903C129.911 162.176 130.116 162.518 130.32 162.86C130.252 162.381 130.116 161.971 129.911 161.629Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M123.357 163.886C123.289 163.681 123.152 163.476 122.947 163.339C122.743 163.202 122.469 163.202 122.196 163.202C121.923 163.271 121.719 163.476 121.65 163.749C121.582 163.955 121.582 164.228 121.582 164.433C121.582 164.57 121.65 164.707 121.65 164.844C121.719 165.117 121.855 165.391 122.06 165.596C121.992 165.391 121.923 165.186 121.923 164.981C121.923 164.775 121.923 164.639 121.923 164.433C121.923 164.023 122.06 163.681 122.333 163.681C122.606 163.613 122.879 163.749 123.084 164.091C123.289 164.365 123.425 164.775 123.63 165.117C123.562 164.707 123.493 164.297 123.357 163.886Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M111.616 168.743C111.616 168.743 106.769 161.082 107.11 156.636C107.247 154.584 109.977 153.216 109.977 153.216C109.977 153.216 118.784 144.324 128.477 150.89C129.638 151.643 132.437 154.105 127.727 156.362C123.153 158.551 113.664 156.636 113.664 156.636C113.664 156.636 114.551 161.492 113.732 166.486C113.459 168.332 111.616 168.743 111.616 168.743Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M113.732 167.854C113.732 167.854 110.114 164.092 108.407 165.46C106.7 166.828 109.841 172.573 112.23 173.052C114.619 173.531 115.097 171.342 115.097 171.342L113.732 167.854Z",
                  fill: "#D3766A"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M109.363 167.102C111.002 167.58 112.094 168.88 112.913 170.316C112.367 169.838 111.684 169.564 111.002 170.248C110.933 170.316 111.002 170.316 111.07 170.316C111.684 170.043 112.162 170.111 112.708 170.59C113.05 170.932 113.323 171.342 113.664 171.753C113.732 171.89 114.005 171.753 113.937 171.616C113.937 171.616 113.937 171.616 113.937 171.548C113.528 169.496 111.548 166.965 109.363 167.102Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M128.136 149.043C126.703 149.18 119.261 152.121 116.394 154.857C113.527 157.525 109.295 164.57 109.09 164.912C108.885 165.254 102.877 153.421 112.093 147.539C122.129 141.109 128.136 149.043 128.136 149.043Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M109.499 164.228C109.499 164.228 112.981 153.079 115.916 149.727C118.852 146.376 126.702 142.272 132.641 142.682C137.284 143.024 129.365 151.643 129.365 151.643C129.365 151.643 128.614 150.343 127.112 150.275C124.245 150.206 119.807 152.669 117.486 154.515C114.551 156.909 109.499 164.228 109.499 164.228Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  opacity: "0.2",
                  d:
                    "M109.499 164.228C109.499 164.228 112.981 153.079 115.916 149.727C118.852 146.376 126.702 142.272 132.641 142.682C137.284 143.024 129.365 151.643 129.365 151.643C129.365 151.643 128.614 150.343 127.112 150.275C124.245 150.206 119.807 152.669 117.486 154.515C114.551 156.909 109.499 164.228 109.499 164.228Z",
                  fill: "black"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M451.104 292.616C451.24 294.668 445.369 295.283 442.912 293.915C442.161 293.505 439.908 291.59 437.246 289.264C431.375 283.997 423.183 276.405 423.183 276.405L417.107 279.141L387.547 288.99L375.055 256.706C375.055 256.706 389.322 250.618 402.976 245.214C405.092 244.394 407.14 243.573 409.12 242.82C409.256 242.752 409.393 242.752 409.461 242.684C418.609 239.195 426.118 236.528 426.937 237.075C429.054 238.443 450.899 290.564 451.104 292.616Z",
                  fill: "#AD6359"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M451.104 292.616C451.241 294.668 445.37 295.283 442.912 293.915C442.161 293.505 439.908 291.59 437.246 289.264C431.307 284.066 423.183 276.405 423.183 276.405L417.107 279.141L416.151 279.483L402.566 245.42C402.703 245.351 402.839 245.283 402.976 245.214C405.092 244.394 407.14 243.573 409.12 242.82C409.257 242.752 409.393 242.752 409.461 242.684C418.609 239.195 426.118 236.528 426.938 237.075C429.054 238.443 450.899 290.564 451.104 292.616Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M451.581 293.368C451.445 291.247 429.804 237.895 427.756 236.391C426.937 235.775 419.018 238.511 409.529 242.068C409.461 242.136 409.324 242.136 409.256 242.205L422.841 276.747L423.387 276.473C423.387 276.473 440.795 293.163 443.253 294.599C445.71 296.035 451.718 295.488 451.581 293.368Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M449.328 293.641C445.437 284.749 430.691 248.429 427.551 239.4C427.551 239.332 427.551 239.332 427.619 239.4C431.647 248.155 446.119 284.544 449.464 293.641C449.533 293.778 449.396 293.778 449.328 293.641Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M424.411 280.577C422.295 277.293 421.134 272.779 422.499 269.017C422.568 268.88 422.772 268.949 422.772 269.085C423.114 273.053 423.728 276.541 424.82 280.371C424.957 280.645 424.547 280.782 424.411 280.577Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M427.005 282.492C424.888 279.209 423.728 274.694 425.093 270.932C425.161 270.796 425.366 270.864 425.366 271.001C425.708 274.968 426.322 278.456 427.414 282.287C427.551 282.56 427.141 282.697 427.005 282.492Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M429.6 284.407C427.484 281.124 426.324 276.61 427.689 272.848C427.757 272.711 427.962 272.779 427.962 272.916C428.303 276.883 428.918 280.372 430.01 284.202C430.078 284.476 429.737 284.612 429.6 284.407Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M422.977 284.612C423.933 281.329 423.387 277.772 423.25 274.352C423.25 274.01 422.841 273.874 422.567 274.01C422.567 273.942 422.499 273.942 422.431 274.01C419.905 276.199 417.584 279.551 416.56 282.766C415.946 284.749 416.082 287.69 418.608 288.306C420.929 288.853 422.431 286.596 422.977 284.612ZM420.519 286.733C416.901 288.922 417.243 283.928 417.789 282.492C418.13 281.534 418.608 280.645 419.018 279.824C419.973 277.978 421.202 276.336 422.363 274.626C422.294 276.268 422.431 277.909 422.431 279.551C422.431 281.534 422.499 285.502 420.519 286.733Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M412.26 264.366C410.416 266.144 411.645 268.743 413.215 270.18C415.673 272.437 419.359 274.284 422.636 274.899C422.704 274.899 422.773 274.831 422.773 274.763C423.046 274.694 423.319 274.421 423.182 274.079C421.612 271.069 420.315 267.717 417.926 265.323C416.492 263.955 414.035 262.724 412.26 264.366ZM419.906 270.111C420.725 271.548 421.407 273.053 422.295 274.421C420.452 273.463 418.608 272.642 416.834 271.548C416.014 271.001 415.195 270.453 414.444 269.838C413.284 268.812 410.553 264.639 414.786 264.776C417.038 264.913 418.95 268.401 419.906 270.111Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  opacity: "0.1",
                  d:
                    "M451.581 293.368C451.718 295.488 445.71 296.035 443.253 294.599C440.727 293.162 423.387 276.473 423.387 276.473L422.841 276.746L412.123 249.386L433.217 247.471C440.249 263.682 451.513 291.863 451.581 293.368Z",
                  fill: "black"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M411.715 285.091C411.715 285.091 347.476 299.866 323.856 295.625C312.523 293.573 304.4 279.004 309.793 267.855C314.844 257.458 345.906 246.856 354.644 240.7C357.375 238.784 357.101 231.192 357.101 231.192L380.107 230.85C380.107 230.85 388.299 243.914 384.818 250.276C384.75 250.412 384.681 250.481 384.613 250.618L394.989 246.651L411.715 285.091Z",
                  fill: "#455A64"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M397.514 267.649C394.988 262.041 392.121 256.637 389.527 251.097C389.459 250.96 389.322 251.028 389.322 251.165C391.78 256.774 394.033 262.451 396.627 267.991C399.221 273.532 401.952 279.004 404.682 284.544C404.751 284.681 404.955 284.613 404.887 284.476C402.429 278.867 400.04 273.258 397.514 267.649Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M384.818 250.823C383.247 251.712 381.746 252.807 380.175 253.833C378.674 254.79 377.103 255.816 375.602 256.705C372.461 258.552 369.253 260.331 365.976 261.972C359.422 265.324 352.664 268.265 345.701 270.727C341.81 272.095 337.918 273.395 333.959 274.421C333.891 274.421 333.891 274.558 334.027 274.558C336.963 273.874 339.83 273.19 342.697 272.369C341.195 273.327 339.693 274.353 338.191 275.31C338.123 275.379 338.191 275.447 338.26 275.447C339.898 274.421 341.605 273.463 343.243 272.437C343.311 272.369 343.311 272.301 343.311 272.232C343.789 272.095 344.267 271.959 344.813 271.822C348.363 270.727 351.845 269.496 355.326 268.06C362.153 265.324 368.707 261.972 374.987 258.142C376.762 257.047 378.469 255.953 380.244 254.79C381.95 253.627 383.657 252.465 385.227 251.097C385.091 250.891 384.954 250.755 384.818 250.823Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M475.748 300.55C475.885 302.602 470.014 303.217 467.556 301.849C466.805 301.439 464.553 299.524 461.89 297.198C456.019 291.931 447.827 284.339 447.827 284.339L441.751 287.075L413.079 296.925L399.699 264.64C399.699 264.64 413.967 258.552 427.62 253.149C429.737 252.328 431.785 251.507 433.764 250.755C433.901 250.686 434.037 250.686 434.106 250.618C443.253 247.129 450.763 244.462 451.582 245.009C453.698 246.309 475.612 298.429 475.748 300.55Z",
                  fill: "#AD6359"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M475.748 300.55C475.885 302.602 470.014 303.217 467.556 301.849C466.805 301.439 464.552 299.524 461.89 297.198C456.019 291.931 447.827 284.271 447.827 284.271L441.82 287.007L441 287.28L426.938 253.354C427.211 253.285 427.484 253.149 427.688 253.08C429.805 252.259 431.853 251.439 433.832 250.686C433.969 250.618 434.105 250.618 434.174 250.549C443.321 247.061 450.831 244.393 451.65 244.941C453.698 246.309 475.612 298.429 475.748 300.55Z",
                  fill: "#EBEBEB"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M476.295 300.96C476.159 298.84 453.767 245.83 451.651 244.325C450.832 243.778 442.913 246.582 433.492 250.207C433.424 250.276 433.287 250.276 433.219 250.344L447.282 284.749L447.828 284.476C447.828 284.476 465.441 300.96 467.966 302.328C470.424 303.696 476.432 303.08 476.295 300.96Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M473.975 301.234C470.016 292.41 454.724 256.295 451.447 247.266C451.447 247.198 451.447 247.198 451.516 247.266C455.68 255.953 470.63 292.137 474.112 301.165C474.18 301.371 474.044 301.439 473.975 301.234Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M448.92 288.512C446.804 285.297 445.506 280.714 446.872 277.02C446.94 276.884 447.145 276.952 447.145 277.089C447.486 281.056 448.169 284.544 449.329 288.375C449.466 288.58 449.056 288.785 448.92 288.512Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M451.516 290.427C449.399 287.212 448.102 282.629 449.468 278.935C449.536 278.799 449.741 278.867 449.741 279.004C450.082 282.971 450.765 286.459 451.925 290.29C452.062 290.495 451.652 290.632 451.516 290.427Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M454.109 292.342C451.993 289.127 450.696 284.544 452.061 280.85C452.13 280.714 452.334 280.782 452.334 280.919C452.676 284.886 453.358 288.374 454.519 292.205C454.655 292.41 454.246 292.547 454.109 292.342Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M447.556 292.684C448.443 289.401 447.829 285.775 447.693 282.424C447.693 282.082 447.283 281.945 447.01 282.082C446.942 282.013 446.942 282.013 446.873 282.082C444.347 284.271 442.095 287.691 441.139 290.905C440.525 292.889 440.729 295.83 443.255 296.377C445.576 296.925 447.01 294.599 447.556 292.684ZM445.098 294.736C441.48 296.993 441.753 292 442.3 290.563C442.641 289.606 443.05 288.717 443.528 287.827C444.484 285.981 445.645 284.339 446.805 282.629C446.805 284.271 446.873 285.912 446.942 287.554C446.942 289.537 447.078 293.505 445.098 294.736Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M436.564 272.506C434.721 274.284 436.018 276.952 437.588 278.32C440.114 280.577 443.732 282.355 447.077 282.903C447.146 282.903 447.214 282.834 447.214 282.766C447.487 282.697 447.76 282.424 447.624 282.082C446.053 279.141 444.688 275.789 442.231 273.395C440.729 272.095 438.271 270.864 436.564 272.506ZM444.21 278.183C445.029 279.619 445.78 281.056 446.668 282.492C444.825 281.603 442.981 280.782 441.207 279.688C440.387 279.141 439.5 278.593 438.749 277.978C437.588 277.02 434.789 272.848 439.022 272.916C441.343 272.985 443.255 276.473 444.21 278.183Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M365.019 230.987L404.614 230.371C404.614 230.371 413.011 251.78 409.529 258.141C406.048 264.503 369.593 273.6 369.593 273.6L419.701 254.516L436.358 293.025C436.358 293.025 375.396 306.364 343.106 303.012C330.954 301.781 323.377 285.912 330.477 273.668C337.918 260.809 365.088 243.299 365.088 243.299L365.019 230.987Z",
                  fill: "#455A64"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M418.405 254.379C403.045 261.425 387.617 268.128 371.779 273.942C369.594 274.763 367.41 275.583 365.157 276.336C362.836 277.157 360.583 278.114 358.262 278.73C358.125 278.73 358.194 278.935 358.33 278.935C360.378 278.182 362.426 277.635 364.474 276.951C366.454 276.267 368.502 275.652 370.482 274.899C371.369 274.626 372.188 274.284 373.076 274.01C372.871 274.147 372.734 274.284 372.53 274.352C371.71 274.899 370.96 275.378 370.14 275.925C368.57 277.02 367.068 278.388 365.362 279.414C365.293 279.482 365.362 279.619 365.43 279.551C367 278.388 368.843 277.567 370.482 276.473C371.301 275.925 372.052 275.378 372.803 274.831C373.485 274.352 374.236 273.873 374.851 273.258C377.377 272.369 379.902 271.411 382.36 270.453C390.211 267.444 398.061 264.229 405.707 260.741C410.008 258.825 414.241 256.773 418.473 254.653C418.814 254.721 418.61 254.311 418.405 254.379Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M423.047 275.241C420.522 269.632 417.654 264.229 415.06 258.688C414.992 258.552 414.855 258.62 414.855 258.757C417.313 264.366 419.566 270.043 422.16 275.583C424.754 281.124 427.485 286.596 430.215 292.136C430.284 292.273 430.489 292.204 430.42 292.068C427.963 286.459 425.573 280.782 423.047 275.241Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M364.338 243.709C359.969 246.103 355.873 249.044 351.845 252.054C347.885 254.995 344.062 258.141 340.376 261.425C338.533 263.135 336.758 264.845 334.983 266.623C333.345 268.333 331.774 270.111 330.409 272.163C328.02 275.72 326.791 279.961 327.132 284.27C327.269 286.527 327.815 288.785 328.702 290.905C329.59 293.025 330.955 294.804 332.389 296.582C332.457 296.651 332.525 296.514 332.457 296.514C331.024 295.009 330.068 293.025 329.385 291.11C328.702 289.263 328.293 287.28 328.156 285.365C327.952 281.261 328.771 277.225 330.955 273.668C333.413 269.633 336.963 266.281 340.376 263.066C343.858 259.715 347.544 256.637 351.367 253.695C353.483 252.054 355.668 250.412 357.921 248.839C360.105 247.266 362.358 245.761 364.542 244.119C364.679 243.846 364.542 243.641 364.338 243.709Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M375.875 245.282C372.667 244.188 369.117 243.709 365.772 243.367C362.427 243.025 359.013 242.82 355.6 242.751C355.532 242.751 355.532 242.888 355.6 242.888C359.013 243.162 362.495 243.641 365.908 244.119C369.185 244.598 372.53 245.351 375.875 245.624C376.012 245.624 376.012 245.351 375.875 245.282Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M402.771 245.761C400.655 245.761 398.539 245.487 396.491 245.214C394.784 244.94 393.009 244.735 391.576 243.641C388.777 241.52 387.616 237.827 387.002 234.543C387.002 234.475 386.865 234.475 386.865 234.543C387.343 238.169 387.48 242.273 390.688 244.735C392.258 245.966 394.17 246.308 396.081 246.445C398.334 246.582 400.655 246.308 402.84 246.035C402.908 245.898 402.908 245.761 402.771 245.761Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M407.141 251.507C406.936 249.455 406.527 247.334 406.049 245.351C405.571 243.23 404.956 241.178 404.274 239.126C403.523 236.801 402.635 234.543 401.748 232.286C401.748 232.218 401.611 232.218 401.611 232.355C402.908 236.185 404.137 240.084 405.093 243.983C405.571 245.898 406.049 247.881 406.39 249.865C406.8 251.78 406.936 253.695 406.458 255.611C405.912 257.526 404.82 259.236 403.318 260.535C403.318 260.535 403.318 260.604 403.318 260.535C406.049 258.347 407.414 254.927 407.141 251.507Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M413.9 263.271C411.238 263.955 408.644 264.913 405.981 265.733C403.319 266.554 400.725 267.443 398.131 268.333C392.874 270.111 387.686 271.889 382.429 273.736C379.494 274.762 376.49 275.857 373.555 276.951C373.486 276.951 373.486 277.088 373.623 277.088C384.204 273.805 394.649 270.316 405.094 266.623C408.029 265.597 411.033 264.639 413.968 263.408C413.968 263.339 413.968 263.203 413.9 263.271Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M374.51 180.234C374.783 192.409 372.257 218.333 367.615 227.293C365.636 231.124 350.48 242.478 341.606 247.266C338.329 249.044 326.314 230.508 329.727 228.114C332.048 226.541 349.183 214.844 350.48 213.134C352.938 209.92 362.086 186.048 367.206 176.198C370.073 170.658 374.305 172.642 374.51 180.234Z",
                  fill: "#AD6359"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M345.019 244.667C344.746 244.94 340.787 249.318 338.124 251.302C336.144 252.806 330.274 256.979 328.362 254.995C327.065 253.627 330.274 250.754 332.458 248.634C333.619 247.54 334.779 245.419 334.028 244.735C332.731 243.436 329.796 246.377 327.952 248.634C324.471 252.943 320.238 262.04 316.62 260.809C315.255 260.33 315.869 256.226 317.03 254.038C314.845 256.91 312.388 261.63 310.818 261.151C309.93 260.878 309.657 258.142 309.725 257.184C308.974 257.8 308.155 258.073 307.404 257.663C306.107 257.047 306.039 255.406 306.448 253.559C306.107 253.627 305.766 253.627 305.424 253.354C302.284 251.096 308.906 238.716 311.978 236.596C321.058 230.371 331.844 226.814 331.844 226.814C336.964 228.388 345.019 244.667 345.019 244.667Z",
                  fill: "#AD6359"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M326.792 241.042C324.539 242.341 322.56 244.12 321.058 246.172C319.146 248.839 318.191 251.438 316.825 254.243C316.757 254.311 316.894 254.38 316.962 254.311C317.644 253.012 320.512 247.813 321.263 246.582C322.696 244.393 324.539 242.478 326.792 241.042C326.86 241.11 326.792 241.042 326.792 241.042Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M323.312 237.553C320.922 239.263 318.533 241.042 316.553 243.231C314.369 245.625 313.14 248.634 311.911 251.575C311.16 253.354 310.478 255.132 309.795 256.911C309.795 256.979 309.863 257.047 309.931 256.979C311.16 253.969 312.526 250.96 313.959 248.087C315.325 245.351 317.031 242.957 319.352 240.905C320.581 239.674 321.946 238.648 323.312 237.553C323.312 237.553 323.312 237.485 323.312 237.553Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M319.079 234.886C316.689 236.391 314.641 237.69 312.935 239.947C310.613 242.889 308.907 247.061 308.292 248.566C307.61 250.207 306.995 251.849 306.449 253.491C306.449 253.559 306.517 253.627 306.586 253.559C307.951 249.865 309.589 246.309 311.433 242.82C312.32 241.179 313.344 239.605 314.709 238.306C316.007 237.006 317.577 235.912 319.079 234.886Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M358.127 193.435L374.852 203.559C374.852 203.559 376.149 182.081 374.784 175.651C373.214 168.401 369.869 170.795 366.046 176.677C362.155 182.628 358.127 193.435 358.127 193.435Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  opacity: "0.1",
                  d:
                    "M358.127 193.435L374.852 203.559C374.852 203.559 376.149 182.081 374.784 175.651C373.214 168.401 369.869 170.795 366.046 176.677C362.155 182.628 358.127 193.435 358.127 193.435Z",
                  fill: "black"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M360.516 190.768C362.837 191.794 369.322 195.761 370.346 196.376C370.892 196.718 373.145 198.155 373.691 198.497C373.759 198.565 373.691 198.634 373.623 198.634C372.53 198.018 371.37 197.471 370.278 196.855C369.185 196.24 362.427 192.409 360.447 190.904C360.447 190.836 360.516 190.768 360.516 190.768Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M407.483 238.442L354.439 240.221C354.508 241.247 356.01 198.497 368.98 172.915C369.868 171.205 378.128 169.085 381.951 172.299C398.54 186.663 407.551 239.126 407.483 238.442Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  opacity: "0.1",
                  d:
                    "M407.073 236.185L354.645 237.963C354.645 237.758 354.645 237.553 354.713 237.348L407.005 235.638C407.005 235.774 407.005 235.98 407.073 236.185ZM406.186 231.739L354.986 233.449C354.986 233.654 354.918 233.859 354.918 234.064L406.322 232.354C406.254 232.218 406.186 232.012 406.186 231.739ZM405.298 227.977L355.259 229.618C355.259 229.824 355.191 230.029 355.191 230.234L405.435 228.592C405.435 228.387 405.367 228.182 405.298 227.977ZM404.479 224.215L355.737 225.856C355.737 226.062 355.669 226.267 355.669 226.472L404.616 224.83C404.547 224.625 404.479 224.42 404.479 224.215ZM403.523 220.453L356.146 222.026C356.146 222.231 356.078 222.436 356.078 222.642L403.66 221.068C403.592 220.863 403.592 220.658 403.523 220.453ZM402.499 216.691L356.624 218.196C356.556 218.401 356.556 218.606 356.556 218.811L402.704 217.238C402.636 217.101 402.568 216.896 402.499 216.691ZM401.475 212.86L357.239 214.365C357.17 214.57 357.17 214.776 357.102 214.981L401.68 213.476C401.612 213.339 401.544 213.066 401.475 212.86ZM400.383 209.098L357.853 210.535C357.785 210.74 357.785 210.945 357.717 211.15L400.588 209.714C400.52 209.509 400.451 209.304 400.383 209.098ZM399.223 205.336L358.536 206.704C358.467 206.91 358.467 207.115 358.399 207.32L399.427 205.952C399.359 205.747 399.291 205.542 399.223 205.336ZM397.994 201.574L359.287 202.874C359.218 203.079 359.218 203.284 359.15 203.49L398.199 202.19C398.13 201.985 398.062 201.78 397.994 201.574ZM396.629 197.812L360.106 199.044C360.038 199.249 359.969 199.454 359.969 199.659L396.833 198.428C396.765 198.223 396.697 198.018 396.629 197.812ZM395.195 194.05L361.062 195.213C360.993 195.418 360.925 195.624 360.925 195.829L395.468 194.666C395.331 194.461 395.263 194.256 395.195 194.05ZM393.625 190.288L362.086 191.314C362.017 191.52 361.949 191.725 361.881 191.93L393.83 190.904C393.83 190.699 393.693 190.494 393.625 190.288ZM391.85 186.526L363.178 187.484C363.11 187.689 363.041 187.894 362.973 188.1L392.123 187.142C392.055 186.937 391.986 186.732 391.85 186.526ZM389.938 182.833L364.543 183.654C364.475 183.859 364.407 184.064 364.338 184.269L390.348 183.38C390.143 183.243 390.007 183.038 389.938 182.833ZM387.617 179.071L365.909 179.755C365.84 179.96 365.772 180.165 365.635 180.37L388.027 179.618C387.89 179.481 387.754 179.276 387.617 179.071ZM384.887 175.377L367.547 175.924C367.41 176.13 367.342 176.335 367.274 176.54L385.433 175.924C385.228 175.788 385.023 175.582 384.887 175.377ZM380.995 171.684L370.005 172.026C369.595 172.231 369.322 172.504 369.117 172.71L381.883 172.299C381.61 172.026 381.337 171.82 380.995 171.684Z",
                  fill: "black"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M371.029 179.823C373.623 180.029 378.402 176.335 379.631 172.505C379.699 172.231 378.88 169.769 377.992 166.759C377.446 164.912 376.968 162.86 376.559 160.945C376.49 160.535 365.09 166.075 365.09 166.075C365.09 166.075 367.001 169.905 367.616 173.189C367.684 173.462 367.684 173.736 367.684 174.009C367.684 174.078 367.684 174.078 367.684 174.146C367.821 175.719 368.298 179.618 371.029 179.823Z",
                  fill: "#AD6359"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M367.752 174.01C367.752 174.078 367.752 174.078 367.752 174.146C368.162 174.146 368.572 174.078 368.981 174.01C376.013 172.573 376.217 163.339 376.217 161.014C374.169 161.698 365.158 166.075 365.158 166.075C365.158 166.075 367.07 169.906 367.684 173.257C367.752 173.531 367.752 173.804 367.752 174.01Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M375.671 146.581C377.651 150.685 377.309 163.407 374.715 166.622C370.96 171.273 363.792 172.778 359.56 168.059C355.464 163.407 356.215 146.855 359.219 143.845C363.588 139.331 372.735 140.562 375.671 146.581Z",
                  fill: "#AD6359"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M364.749 155.884L364.817 155.952C364.749 156.841 364.885 157.799 365.636 158.073V158.141C364.681 158.004 364.612 156.705 364.749 155.884Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M365.569 154.994C366.934 154.926 367.002 157.662 365.705 157.73C364.408 157.799 364.408 155.063 365.569 154.994Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M359.835 156.089L359.766 156.157C359.835 157.046 359.698 158.004 358.947 158.278V158.346C359.903 158.209 359.971 156.91 359.835 156.089Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M359.015 155.2C357.65 155.131 357.582 157.867 358.879 157.936C360.108 158.072 360.176 155.268 359.015 155.2Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M366.593 153.695C366.183 153.627 365.91 153.49 365.501 153.353C365.091 153.216 364.75 153.148 364.477 152.806C364.34 152.601 364.408 152.259 364.545 152.122C364.955 151.78 365.501 151.78 365.979 151.917C366.525 152.053 366.934 152.327 367.207 152.806C367.617 153.285 367.139 153.832 366.593 153.695Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M357.923 153.832C358.332 153.763 358.674 153.626 359.015 153.558C359.424 153.421 359.766 153.353 360.039 153.011C360.175 152.806 360.175 152.464 359.971 152.327C359.561 151.916 359.015 151.985 358.537 152.053C357.991 152.19 357.581 152.464 357.24 152.874C356.967 153.353 357.445 153.968 357.923 153.832Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M365.705 163.818C365.5 164.024 365.295 164.297 365.022 164.366C364.749 164.366 364.339 164.297 364.066 164.16C364.066 164.16 363.998 164.16 363.998 164.229C364.203 164.571 364.681 164.776 365.09 164.708C365.5 164.639 365.636 164.297 365.773 163.955C365.773 163.818 365.705 163.818 365.705 163.818Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M364.749 161.287C364.271 162.04 363.589 162.45 362.838 162.587C362.496 162.655 362.155 162.655 361.814 162.655C361.745 162.655 361.677 162.655 361.609 162.655C361.541 162.655 361.472 162.655 361.404 162.655C361.336 162.655 361.267 162.587 361.199 162.45V162.382V162.313C361.199 161.629 361.199 160.672 361.199 160.672C360.994 160.808 359.766 161.356 359.766 161.014C359.902 158.141 360.039 154.994 360.721 152.19C360.721 152.122 360.858 152.122 360.858 152.19C360.858 154.926 360.38 157.662 360.312 160.466C360.721 160.33 361.336 160.056 361.677 160.056C361.745 160.056 361.541 161.971 361.609 162.313C362.701 162.45 363.52 162.108 364.613 161.356C364.749 161.15 364.817 161.219 364.749 161.287Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M362.154 162.313C362.154 162.313 362.769 163.066 363.588 163.339C363.861 163.408 364.202 163.476 364.544 163.408C365.226 163.202 365.226 162.587 365.09 162.04C364.953 161.629 364.748 161.219 364.748 161.219C364.748 161.219 363.793 162.176 362.154 162.313Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M363.588 163.408C363.861 163.476 364.202 163.544 364.544 163.476C365.226 163.271 365.226 162.655 365.09 162.108C364.339 162.176 363.588 162.655 363.588 163.408Z",
                  fill: "#FF98B9"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M377.515 157.388C377.72 156.226 379.427 143.572 378.949 142.272C378.539 141.109 377.242 141.725 377.242 141.656C377.242 141.588 377.038 140.494 376.355 140.152C375.741 139.878 374.853 140.357 374.853 140.357C374.853 140.357 374.512 139.194 373.761 138.989C373.01 138.715 372.327 139.468 372.327 139.468C372.327 139.468 371.986 138.373 371.03 138.168C370.074 137.963 369.665 138.852 369.665 138.852C369.665 138.852 369.255 137.758 368.436 137.621C367.617 137.484 367.071 138.373 367.071 138.373C367.071 138.373 366.525 137.416 365.637 137.484C364.681 137.552 364.408 138.647 364.408 138.647C364.408 138.647 363.726 137.689 362.838 137.758C361.951 137.826 361.746 138.92 361.746 138.92C361.746 138.92 361.268 137.963 360.449 138.1C359.63 138.236 359.561 139.399 359.561 139.399C359.561 139.399 359.015 138.373 358.059 138.784C356.626 139.399 357.172 146.581 357.104 149.728C357.104 149.728 357.377 148.223 357.991 148.086C358.606 147.949 359.22 148.907 360.381 149.044C362.087 149.249 364.681 146.992 367.071 147.265C369.392 147.539 371.303 149.728 372.464 153.216C373.829 157.115 377.038 160.193 377.515 157.388Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M365.568 160.603C363.588 160.329 362.223 158.483 362.496 156.567C362.769 154.584 364.612 153.216 366.523 153.489C368.503 153.763 369.869 155.61 369.595 157.525C369.391 159.167 368.025 160.466 366.455 160.603C366.114 160.671 365.841 160.671 365.568 160.603ZM362.905 156.636C362.7 158.346 363.861 159.919 365.568 160.124C367.274 160.329 368.844 159.167 369.049 157.457C369.254 155.747 368.094 154.173 366.387 153.968C366.114 153.9 365.841 153.9 365.636 153.968C364.271 154.105 363.11 155.131 362.905 156.636Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M357.922 160.535C356.42 160.535 355.26 158.893 355.26 156.909C355.26 155.952 355.533 155.063 356.011 154.379C356.489 153.695 357.171 153.284 357.922 153.284C358.673 153.284 359.356 153.695 359.834 154.379C360.311 155.063 360.585 155.952 360.585 156.909C360.585 158.825 359.492 160.329 358.127 160.466C358.127 160.535 357.99 160.535 357.922 160.535ZM356.42 154.721C356.011 155.336 355.738 156.089 355.738 156.978C355.738 158.688 356.693 160.124 357.922 160.124C359.151 160.124 360.107 158.756 360.107 156.978C360.107 156.157 359.902 155.336 359.424 154.721C359.014 154.173 358.468 153.831 357.922 153.831C357.854 153.831 357.786 153.831 357.717 153.831C357.308 153.9 356.83 154.173 356.42 154.721Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M362.565 156.978L362.907 156.636C362.36 156.157 361.132 155.542 360.244 156.499L360.585 156.841C361.336 155.952 362.565 156.91 362.565 156.978Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M378.606 157.935L379.016 157.73C378.879 157.525 377.992 155.747 376.9 155.61C375.876 155.473 369.459 156.02 369.186 156.02L369.254 156.499C371.097 156.362 376.08 155.952 376.831 156.089C377.582 156.225 378.333 157.457 378.606 157.935Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M374.101 157.32C374.101 157.32 376.354 152.942 378.334 153.695C380.314 154.447 378.948 160.535 376.968 161.629C374.92 162.724 373.896 160.877 373.896 160.877L374.101 157.32Z",
                  fill: "#AD6359"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M377.925 155.405C377.925 155.405 377.993 155.473 377.925 155.405C376.56 156.294 375.945 157.799 375.604 159.304C375.945 158.688 376.56 158.278 377.379 158.756C377.447 158.756 377.379 158.825 377.379 158.825C376.765 158.756 376.355 158.962 375.945 159.509C375.672 159.919 375.536 160.33 375.399 160.808C375.331 160.945 375.126 160.945 375.126 160.74C375.126 160.74 375.126 160.74 375.126 160.672C374.785 158.756 375.877 155.884 377.925 155.405Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M382.908 190.562C379.904 203.9 372.463 224.557 365.978 226.13C356.625 228.319 335.19 214.776 328.772 210.125C326.383 208.346 339.559 190.836 342.426 192.341C346.317 194.393 356.83 202.737 359.288 202.806C360.994 202.806 368.231 191.178 375.33 182.012C385.366 168.879 385.161 180.576 382.908 190.562Z",
                  fill: "#AD6359"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M332.459 212.86C324.608 209.098 314.573 204.858 309.112 196.65C308.02 195.076 308.224 193.572 308.224 193.572C305.698 189.946 306.654 187.689 306.654 187.689C305.357 183.585 306.654 181.396 306.654 181.396C306.654 181.396 303.719 177.087 306.04 174.898C308.634 172.436 312.184 178.934 316.348 181.328C325.837 186.732 340.924 191.793 343.791 193.093L332.459 212.86Z",
                  fill: "#AD6359"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M322.286 194.05C319.487 192.409 316.757 190.836 314.231 188.852C311.432 186.663 309.179 184.064 306.722 181.465C306.653 181.396 306.517 181.465 306.585 181.602C310.203 187.005 316.279 191.725 322.218 194.256C322.355 194.256 322.423 194.119 322.286 194.05Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M319.896 200.275C317.302 198.496 312.728 195.418 306.789 187.621H306.721C309.929 193.161 314.298 197.265 319.828 200.343C319.964 200.48 320.033 200.411 319.896 200.275Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M318.531 203.627C314.23 200.48 311.909 197.949 308.291 193.64H308.223C311.841 198.975 313.752 200.48 318.463 203.763C318.599 203.9 318.667 203.763 318.531 203.627Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M318.873 192.546C318.873 192.546 329.659 183.859 331.025 182.901C332.731 181.602 352.256 175.104 352.46 173.941C352.733 172.026 332.253 169.427 328.499 169.222C325.632 169.085 308.906 173.326 308.906 173.326L318.873 192.546Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("g", { attrs: { opacity: "0.1" } }, [
                _c("path", {
                  attrs: {
                    d:
                      "M318.873 192.546C318.873 192.546 329.659 183.859 331.025 182.901C332.731 181.602 352.256 175.104 352.46 173.941C352.733 172.026 332.253 169.427 328.499 169.222C325.632 169.085 308.906 173.326 308.906 173.326L318.873 192.546Z",
                    fill: "black"
                  }
                })
              ]),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M318.465 191.793C318.465 191.793 329.251 183.107 330.616 182.149C332.323 180.849 352.325 175.104 352.462 173.941C352.735 172.026 331.845 168.674 328.022 168.469C325.155 168.332 308.43 172.573 308.43 172.573L318.465 191.793Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M331.914 180.986C331.982 181.123 332.051 181.192 332.119 181.328C331.368 181.67 330.822 181.944 330.549 182.081C330.071 182.423 328.501 183.654 326.658 185.159C326.316 184.954 326.043 184.748 325.838 184.475C324.814 183.175 325.36 181.397 327.067 180.439C328.706 179.482 330.89 179.755 331.914 180.986Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M318.192 183.449C319.831 182.491 320.377 180.644 319.421 179.413C318.397 178.113 316.212 177.908 314.574 178.866C312.936 179.823 312.39 181.67 313.345 182.901C314.301 184.133 316.486 184.406 318.192 183.449Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M323.518 169.016C323.996 169.221 324.405 169.495 324.678 169.905C325.702 171.205 325.156 172.983 323.518 173.941C321.811 174.899 319.695 174.625 318.671 173.394C317.852 172.368 318.056 171 319.012 169.974C320.582 169.632 322.152 169.29 323.518 169.016Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M336.487 174.967C338.126 174.009 338.672 172.162 337.716 170.931C336.692 169.632 334.507 169.426 332.869 170.384C331.231 171.342 330.684 173.188 331.64 174.42C332.596 175.719 334.78 175.924 336.487 174.967Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M348.981 175.241C349.049 175.309 349.117 175.446 349.186 175.514C347.342 176.198 344.953 177.019 342.495 177.84C342.222 176.745 342.837 175.446 344.134 174.693C345.84 173.667 347.957 173.941 348.981 175.241Z",
                  fill: "#BC5648"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M310.272 182.559C312.389 187.142 314.778 190.425 316.758 191.93C318.874 193.64 320.512 193.366 321.741 192.614C322.833 191.93 323.38 190.699 322.356 188.989C320.99 186.732 318.737 183.517 317.372 180.644C315.938 177.566 315.188 174.42 314.232 172.162C313.344 170.042 312.389 168.879 310.477 169.221C308.634 169.563 307.405 170.658 307.473 172.915C307.542 175.582 308.907 179.618 310.272 182.559Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  opacity: "0.2",
                  d:
                    "M310.272 182.559C312.389 187.142 314.778 190.425 316.758 191.93C318.874 193.64 320.512 193.366 321.741 192.614C322.833 191.93 323.38 190.699 322.356 188.989C320.99 186.732 318.737 183.517 317.372 180.644C315.938 177.566 315.188 174.42 314.232 172.162C313.344 170.042 312.389 168.879 310.477 169.221C308.634 169.563 307.405 170.658 307.473 172.915C307.542 175.582 308.907 179.618 310.272 182.559Z",
                  fill: "black"
                }
              }),
              _vm._v(" "),
              _c("g", { attrs: { opacity: "0.1" } }, [
                _c("path", {
                  attrs: {
                    d:
                      "M309.999 172.846C310.408 172.778 310.682 172.436 310.682 172.094C310.613 171.752 310.272 171.547 309.862 171.615C309.453 171.684 309.18 172.026 309.18 172.368C309.248 172.71 309.589 172.915 309.999 172.846Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M318.464 191.794C318.873 191.725 319.146 191.383 319.146 191.041C319.078 190.699 318.737 190.494 318.327 190.562C317.918 190.631 317.645 190.973 317.645 191.315C317.645 191.657 318.054 191.862 318.464 191.794Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M312.321 171.684C312.526 171.41 312.457 171.136 312.184 170.931C311.911 170.794 311.502 170.863 311.297 171.136C311.092 171.41 311.16 171.684 311.433 171.889C311.706 172.026 312.116 171.889 312.321 171.684Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M341.743 171.752C341.947 171.478 341.879 171.205 341.606 171C341.333 170.863 340.923 170.931 340.719 171.205C340.514 171.478 340.582 171.752 340.855 171.957C341.128 172.094 341.538 172.026 341.743 171.752Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M310.614 170.931C310.819 170.726 310.75 170.453 310.477 170.316C310.204 170.179 309.863 170.247 309.727 170.453C309.522 170.658 309.59 170.931 309.863 171.068C310.136 171.205 310.477 171.137 310.614 170.931Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M344.2 171.889C344.405 171.684 344.336 171.41 344.063 171.273C343.79 171.137 343.449 171.205 343.312 171.41C343.108 171.615 343.176 171.889 343.449 172.026C343.654 172.163 343.995 172.094 344.2 171.889Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M326.452 178.866C326.657 178.661 326.588 178.387 326.315 178.25C326.042 178.114 325.701 178.182 325.564 178.387C325.36 178.592 325.428 178.866 325.701 179.003C325.906 179.14 326.247 179.071 326.452 178.866Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M323.175 186.869C323.243 186.732 323.243 186.595 323.107 186.595C322.97 186.527 322.834 186.595 322.697 186.664C322.629 186.8 322.629 186.937 322.765 186.937C322.902 187.006 323.107 187.006 323.175 186.869Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M317.236 173.052C317.304 172.915 317.304 172.778 317.167 172.778C317.031 172.71 316.894 172.778 316.758 172.847C316.689 172.984 316.689 173.12 316.826 173.12C317.031 173.189 317.167 173.12 317.236 173.052Z",
                    fill: "black"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d:
                      "M343.927 174.146C343.995 174.009 343.995 173.873 343.859 173.873C343.722 173.873 343.586 173.873 343.449 173.941C343.381 174.078 343.381 174.215 343.517 174.215C343.654 174.283 343.79 174.283 343.927 174.146Z",
                    fill: "black"
                  }
                })
              ]),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M328.226 187.142C329.728 187.347 329.865 186.527 327.953 184.611C326.042 182.628 316.894 176.472 319.352 173.462C321.809 170.453 334.575 179.345 337.442 182.901C340.378 186.39 343.791 193.161 343.791 193.161C340.924 191.862 333.756 189.536 328.226 187.142Z",
                  fill: "#AD6359"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M364.477 195.418L379.973 209.44C379.973 209.44 385.639 187.142 385.503 180.165C385.298 172.231 381.338 174.078 376.082 179.481C370.894 184.885 364.477 195.418 364.477 195.418Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  opacity: "0.1",
                  d:
                    "M364.477 195.418L379.973 209.44C379.973 209.44 385.639 187.142 385.503 180.165C385.298 172.231 381.338 174.078 376.082 179.481C370.894 184.885 364.477 195.418 364.477 195.418Z",
                  fill: "black"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M367.549 193.093C369.733 194.598 375.741 200.07 376.765 200.959C377.311 201.438 379.291 203.421 379.837 203.9C379.905 203.968 379.768 204.037 379.7 203.968C378.676 203.079 377.584 202.258 376.56 201.438C375.536 200.548 369.255 195.213 367.412 193.161C367.412 193.161 367.48 193.093 367.549 193.093Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M356.08 201.37C356.694 201.438 357.172 201.712 357.718 201.917C357.992 202.054 358.196 202.19 358.469 202.327C358.742 202.464 358.947 202.669 359.22 202.738C358.947 202.806 358.606 202.738 358.333 202.669C358.06 202.601 357.787 202.464 357.514 202.327C356.968 202.122 356.49 201.848 356.08 201.37Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M342.904 218.948C345.089 219.837 347.273 220.863 349.39 221.821L352.598 223.326C353.69 223.805 354.714 224.352 355.807 224.762C354.646 224.557 353.486 224.215 352.393 223.805C351.301 223.394 350.209 222.915 349.117 222.437C346.932 221.411 344.884 220.316 342.904 218.948Z",
                  fill: "#263238"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M301.533 289.811H229.512V299.045H301.533V289.811Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M229.58 289.811H182.203V299.045H229.58V289.811Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  opacity: "0.3",
                  d: "M229.58 289.811H182.203V299.045H229.58V289.811Z",
                  fill: "black"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M176.059 294.735L157.695 234.543L163.771 229.55L182.203 289.811L176.059 294.735Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  opacity: "0.3",
                  d:
                    "M176.059 294.735L157.695 234.543L163.771 229.55L182.203 289.811L176.059 294.735Z",
                  fill: "black"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M254.498 289.811H182.203L163.771 229.55L236.066 229.687L254.498 289.811Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  opacity: "0.2",
                  d:
                    "M254.498 289.811H182.203L163.771 229.55L236.066 229.687L254.498 289.811Z",
                  fill: "black"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M246.716 289.811L230.264 236.253L236.066 229.55L254.498 289.811H246.716Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  opacity: "0.3",
                  d:
                    "M246.716 289.811L230.264 236.253L236.066 229.55L254.498 289.811H246.716Z",
                  fill: "black"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M230.263 236.253L236.066 229.55H163.771L165.888 236.459L230.263 236.253Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M188.484 294.462C188.484 294.599 188.484 294.667 188.416 294.735C188.348 294.804 188.348 294.941 188.28 295.009C188.211 295.077 188.143 295.146 188.075 295.146C188.007 295.214 187.87 295.214 187.802 295.214C187.734 295.214 187.597 295.214 187.529 295.146C187.46 295.077 187.392 295.077 187.324 295.009C187.256 294.941 187.187 294.872 187.187 294.735C187.119 294.667 187.119 294.53 187.119 294.462C187.119 294.393 187.119 294.257 187.187 294.188C187.256 294.12 187.256 293.983 187.324 293.915C187.392 293.846 187.46 293.778 187.529 293.778C187.597 293.709 187.734 293.709 187.802 293.709C187.87 293.709 188.007 293.709 188.075 293.778C188.143 293.846 188.211 293.846 188.28 293.915C188.348 293.983 188.416 294.051 188.416 294.188C188.416 294.257 188.484 294.393 188.484 294.462Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M191.693 296.993V291.863H193.741C193.946 291.863 194.151 291.931 194.356 292C194.561 292.068 194.697 292.205 194.834 292.41C194.97 292.547 195.107 292.752 195.175 292.957C195.243 293.162 195.312 293.368 195.312 293.573C195.312 293.778 195.243 293.983 195.175 294.188C195.107 294.394 194.97 294.599 194.834 294.736C194.697 294.872 194.561 295.009 194.356 295.146C194.151 295.214 193.946 295.283 193.741 295.283H192.581V296.993H191.693ZM192.649 294.394H193.741C193.946 294.394 194.083 294.325 194.151 294.188C194.287 294.052 194.356 293.846 194.356 293.573C194.356 293.436 194.356 293.299 194.288 293.231C194.219 293.094 194.219 293.026 194.151 292.957C194.083 292.889 194.014 292.82 193.946 292.82C193.878 292.752 193.81 292.752 193.673 292.752H192.581V294.394H192.649Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M198.178 296.993V291.863H199.133V296.993H198.178Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M202.07 296.24L204.869 292.752H202.207V291.863H205.962V292.615L203.299 296.104H205.962V296.993H202.07V296.24Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M208.623 296.24L211.422 292.752H208.76V291.863H212.514V292.615L209.852 296.104H212.514V296.993H208.623V296.24Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M216.816 291.863H217.635L219.478 296.993H218.523L218.045 295.693H216.406L215.928 296.993H214.973L216.816 291.863ZM217.908 295.009L217.225 293.026L216.543 295.009H217.908Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M223.711 294.462C223.711 294.599 223.711 294.667 223.643 294.735C223.574 294.804 223.574 294.941 223.506 295.009C223.438 295.077 223.37 295.146 223.301 295.146C223.233 295.214 223.097 295.214 223.028 295.214C222.96 295.214 222.824 295.214 222.755 295.146C222.687 295.077 222.619 295.077 222.55 295.009C222.482 294.941 222.414 294.872 222.414 294.735C222.346 294.667 222.346 294.53 222.346 294.462C222.346 294.393 222.346 294.257 222.414 294.188C222.482 294.12 222.482 293.983 222.55 293.915C222.619 293.846 222.687 293.778 222.755 293.778C222.824 293.709 222.96 293.709 223.028 293.709C223.097 293.709 223.233 293.709 223.301 293.778C223.37 293.846 223.438 293.846 223.506 293.915C223.574 293.983 223.643 294.051 223.643 294.188C223.711 294.257 223.711 294.393 223.711 294.462Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M112.076 249.873L99.4775 273.993L100.687 274.627L113.286 250.507L112.076 249.873Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M113.253 250.481L112.844 251.233H111.342L111.751 250.413L113.253 250.481Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M112.23 252.396L111.82 253.217L110.318 253.148L110.728 252.396H112.23Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M111.274 254.38L110.864 255.132L109.362 255.064L109.704 254.312L111.274 254.38Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M110.25 256.295L109.841 257.047H108.339L108.748 256.227L110.25 256.295Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M109.226 258.21L108.816 259.031L107.314 258.962L107.724 258.21H109.226Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M108.202 260.194L107.793 260.946L106.291 260.878L106.701 260.125L108.202 260.194Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M107.178 262.109L106.768 262.861H105.267L105.676 262.041L107.178 262.109Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M106.154 264.024L105.744 264.845L104.242 264.777L104.652 264.024H106.154Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M105.198 266.008L104.789 266.76H103.219L103.628 265.939L105.198 266.008Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M104.174 267.923L103.765 268.744L102.263 268.675L102.672 267.854L104.174 267.923Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M103.151 269.838L102.741 270.659L101.239 270.591L101.649 269.838H103.151Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M102.126 271.822L101.717 272.574H100.215L100.624 271.753L102.126 271.822Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M101.102 273.737L100.693 274.558H100.488L99.4639 274.01L99.6004 273.737H101.102Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M110.045 268.333L107.929 294.393H93.6612L91.5449 268.333H110.045Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M111.274 266.007H90.248V269.838H111.274V266.007Z",
                  fill: "#455A64"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M109.841 266.007H91.6816L92.7056 263.408H108.748L109.841 266.007Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M108.134 292L107.93 294.394H93.6618L93.457 292H108.134Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M108.953 282.218L108.748 284.612C108.475 284.407 108.27 284.133 108.065 283.928C106.768 282.629 105.539 281.397 104.037 280.645C103.286 280.235 102.467 280.029 101.716 280.029C101.511 280.029 101.375 280.029 101.17 280.029L100.692 280.098C100.556 280.098 100.351 280.166 100.146 280.235C99.9413 280.303 99.8048 280.303 99.6683 280.371C99.2587 280.508 98.9173 280.645 98.576 280.782C98.4395 280.85 98.2347 280.919 98.0981 280.987C97.9616 281.055 97.8251 281.124 97.7568 281.124C97.0741 281.466 96.3915 281.876 95.5723 282.218C94.7531 282.629 93.9339 283.039 92.9099 283.244H92.8416L92.7051 281.055C93.1829 280.713 93.5925 280.303 94.0704 279.893C94.2752 279.687 94.5483 279.551 94.7531 279.345C94.9579 279.14 95.2309 279.003 95.504 278.798C95.7771 278.593 96.0501 278.456 96.3232 278.251C97.1424 277.772 98.2347 277.362 99.2587 277.362C99.5317 277.362 99.8048 277.362 100.01 277.362C100.283 277.43 100.487 277.362 100.761 277.499L101.58 277.704C101.853 277.772 102.058 277.909 102.262 278.046C103.15 278.525 103.901 279.072 104.652 279.551C106.017 280.577 107.451 281.534 108.953 282.218Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M108.748 284.544L108.612 286.049C107.724 286.117 106.768 286.117 105.881 285.912L105.198 285.775L104.516 285.501C104.106 285.365 103.696 285.091 103.287 284.886C102.536 284.407 101.785 283.928 101.102 283.381C100.078 282.56 99.0543 281.671 98.0303 280.919C97.689 280.645 97.3476 280.44 96.938 280.235C96.5967 280.029 96.1871 279.824 95.7775 279.687C95.5727 279.619 95.3679 279.551 95.1631 279.482C94.9583 279.414 94.8218 279.345 94.617 279.345C94.617 279.345 94.617 279.345 94.5487 279.345C93.7978 279.209 93.1151 279.277 92.3642 279.414L92.2959 278.251C92.4324 278.251 92.569 278.251 92.7055 278.251C92.9786 278.251 93.1834 278.251 93.3882 278.319L94.0708 278.456C94.2756 278.525 94.5487 278.593 94.7535 278.661C94.9583 278.73 95.0948 278.798 95.2996 278.867C95.9823 279.14 96.5284 279.551 97.1428 279.893C97.5524 280.166 98.0303 280.44 98.4399 280.782C99.4639 281.466 100.488 282.15 101.512 282.765C103.014 283.655 104.516 284.339 106.086 284.612C106.495 284.749 106.837 284.681 107.246 284.681C107.656 284.612 108.066 284.612 108.407 284.544C108.612 284.612 108.68 284.544 108.748 284.544Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M327.644 259.93L315.045 284.049L316.255 284.684L328.853 260.564L327.644 259.93Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M328.841 260.536L328.432 261.356L326.93 261.288L327.339 260.467L328.841 260.536Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M327.816 262.451L327.406 263.271L325.904 263.203L326.314 262.451H327.816Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M326.792 264.435L326.383 265.187H324.881L325.29 264.366L326.792 264.435Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M325.837 266.35L325.428 267.17L323.857 267.102L324.267 266.35H325.837Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M324.814 268.334L324.404 269.086L322.902 269.018L323.312 268.265L324.814 268.334Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M323.788 270.249L323.379 271.001H321.877L322.287 270.18L323.788 270.249Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M322.765 272.164L322.355 272.984L320.854 272.916L321.263 272.164H322.765Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M321.742 274.147L321.332 274.9H319.83L320.24 274.079L321.742 274.147Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M320.716 276.063L320.307 276.815H318.805L319.214 275.994L320.716 276.063Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M319.693 277.978L319.351 278.798L317.781 278.73L318.191 277.978H319.693Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M318.738 279.961L318.328 280.714H316.826L317.236 279.893L318.738 279.961Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M317.712 281.876L317.303 282.697L315.801 282.629L316.21 281.876H317.712Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M316.689 283.86L316.28 284.612H316.075L315.051 284.065L315.187 283.792L316.689 283.86Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M325.631 278.388L323.515 304.517H309.179L307.131 278.388H325.631Z",
                  fill: "#FFC727"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M326.792 276.062H305.766V279.893H326.792V276.062Z",
                  fill: "#455A64"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M325.358 276.062H307.199L308.291 273.463H324.334L325.358 276.062Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M323.72 302.054L323.515 304.517H309.179L309.043 302.054H323.72Z",
                  fill: "#37474F"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M324.472 292.273L324.267 294.667C323.994 294.462 323.789 294.188 323.585 293.983C322.288 292.683 321.059 291.452 319.557 290.7C318.806 290.289 317.987 290.084 317.236 290.084C317.031 290.084 316.894 290.084 316.69 290.084L316.212 290.153C316.075 290.153 315.87 290.221 315.666 290.289C315.461 290.358 315.324 290.358 315.188 290.426C314.778 290.563 314.437 290.7 314.096 290.837C313.959 290.905 313.754 290.973 313.618 291.042C313.481 291.11 313.345 291.179 313.276 291.179C312.594 291.521 311.911 291.931 311.092 292.273C310.273 292.683 309.453 293.094 308.429 293.299H308.361L308.225 291.11C308.702 290.768 309.112 290.358 309.59 289.947C309.795 289.742 310.068 289.605 310.273 289.4C310.477 289.195 310.75 289.058 311.024 288.853C311.297 288.648 311.57 288.511 311.843 288.306C312.662 287.827 313.754 287.417 314.778 287.417C315.051 287.417 315.324 287.417 315.529 287.417C315.802 287.485 316.007 287.416 316.28 287.553L317.099 287.759C317.372 287.827 317.577 287.964 317.782 288.101C318.669 288.579 319.42 289.126 320.171 289.605C321.605 290.7 322.97 291.589 324.472 292.273Z",
                  fill: "white"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d:
                    "M324.335 294.667L324.199 296.172C323.311 296.24 322.355 296.24 321.468 296.035L320.785 295.898L320.103 295.624C319.693 295.488 319.283 295.214 318.874 295.009C318.123 294.53 317.372 294.051 316.689 293.504C315.665 292.683 314.641 291.794 313.617 291.042C313.276 290.768 312.935 290.563 312.525 290.358C312.184 290.152 311.774 289.947 311.364 289.81C311.16 289.742 310.955 289.674 310.75 289.605C310.545 289.537 310.409 289.468 310.204 289.468C310.204 289.468 310.204 289.468 310.136 289.468C309.385 289.332 308.702 289.4 307.951 289.537L307.883 288.374C308.019 288.374 308.156 288.374 308.292 288.374C308.565 288.374 308.77 288.374 308.975 288.442L309.658 288.579C309.863 288.648 310.136 288.716 310.34 288.784C310.545 288.853 310.682 288.921 310.887 288.99C311.569 289.263 312.115 289.674 312.73 290.016C313.139 290.289 313.617 290.563 314.027 290.905C315.051 291.589 316.075 292.273 317.099 292.888C318.601 293.778 320.103 294.462 321.673 294.735C322.082 294.872 322.424 294.804 322.833 294.804C323.243 294.735 323.652 294.735 323.994 294.667C324.13 294.667 324.267 294.667 324.335 294.667Z",
                  fill: "white"
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "auth-modal__wrapper" }, [
          _c("h1", { staticClass: "auth-modal__title" }, [_vm._v("Вход")]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isFirstStep,
                  expression: "isFirstStep"
                }
              ],
              staticClass: "auth-modal__container-phone"
            },
            [
              _c("app-input", {
                attrs: {
                  label: "Номер телефона",
                  "data-attr": "data-phone-input",
                  "input-mode": "tel",
                  "max-length": _vm.maxPhoneLength,
                  "is-error": _vm.phoneTextError !== null,
                  "text-error": _vm.phoneTextError
                },
                on: {
                  input: _vm.clearAuthPhoneError,
                  "enter-pressed": _vm.sendAuthPhone
                },
                model: {
                  value: _vm.authPhone,
                  callback: function($$v) {
                    _vm.authPhone = $$v
                  },
                  expression: "authPhone"
                }
              }),
              _vm._v(" "),
              _c("app-progress-button", {
                attrs: {
                  "button-text": "Получить код",
                  "in-progress": _vm.inPhoneProgress
                },
                on: { click: _vm.sendAuthPhone }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "auth-modal__policy" }, [
                _vm._v(
                  "\n          Нажимая на кнопку, вы даете согласие на обработку\n          "
                ),
                _c(
                  "a",
                  {
                    staticClass: "auth-modal__policy-link",
                    attrs: { href: "#" }
                  },
                  [_vm._v("персональных данных")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isFirstStep,
                  expression: "!isFirstStep"
                }
              ],
              staticClass: "auth-modal__container-code"
            },
            [
              _c("p", { staticClass: "auth-modal__text" }, [
                _vm._v(
                  "\n          Дождитесь входящего вызова и введите последние 4 цифры номера\n        "
                )
              ]),
              _vm._v(" "),
              _c("app-auth-code", {
                attrs: {
                  "is-error": _vm.codeTextError !== null,
                  "text-error": _vm.codeTextError
                },
                on: {
                  "emit-code": _vm.setAuthCode,
                  "tap-enter": _vm.sendAuthCode
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "auth-modal__links" }, [
                _vm.timeLeft > 0
                  ? _c(
                      "button",
                      {
                        staticClass: "auth-modal__repeat-code",
                        attrs: { disabled: _vm.timeLeft > 0 }
                      },
                      [
                        _vm._v("\n            Отправить код повторно"),
                        _c("br"),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.timeLeft !== 0
                                ? "(Станет доступно через " + _vm.timeLeft + ")"
                                : ""
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "auth-modal__repeat-code",
                        on: { click: _vm.sendAuthPhone }
                      },
                      [
                        _vm._v(
                          "\n            Отправить код повторно\n          "
                        )
                      ]
                    ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "auth-modal__change-phone",
                    on: { click: _vm.clearAuthRequest }
                  },
                  [_vm._v("\n            Поменять телефон\n          ")]
                )
              ]),
              _vm._v(" "),
              _c("app-progress-button", {
                attrs: {
                  "button-text": "Войти",
                  "in-progress": _vm.inCodeProgress
                },
                on: { click: _vm.sendAuthCode }
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f8eb57f", { render: render, staticRenderFns: staticRenderFns })
  }
}